// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T18:40:19.783Z
// Property: FUZE Woodstock (ID: 6767906449167809)
// Collections: 25 amenities, 6 floorplans (live), 43 photos, 73 POIs, 4 reviews, 7 virtual tours, 5 office hours, 1 special offers (live), 14 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162477",
  "multihub_property_id": "6767906449167809",
  "property_external_id": "5nsnhqp",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/fuze-woodstock-woodstock-on/5nsnhqp/",
  "property_google_business_url": "https://www.google.com/maps/place/FUZE+Woodstock/@43.1170104,-80.7498514,1670m/data=!3m2!1e3!4b1!4m6!3m5!1s0x882c1f22bb375f79:0xe467155b6a54e0b4!8m2!3d43.1170104!4d-80.7498514!16s%2Fg%2F11wnqtypnx!5m1!1e2?entry=ttu&g_ep=EgoyMDI2MTAxMS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "58883866514",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "fuze-woodstock",
  "property_name": "FUZE Woodstock",
  "property_website_url": "https://www.fuzewoodstock.com/",
  "property_domain": "https://www.fuzewoodstock.com/",
  "property_address": "140 Ferguson Dr",
  "property_full_address": "140 Ferguson Dr, Woodstock, ON N4V 0E3, Canada",
  "property_address_1": "140 Ferguson Dr",
  "property_address_2": null,
  "property_address_city": "Woodstock",
  "property_address_state": "ON",
  "property_address_zip_full": null,
  "property_address_zip": "N4V 0E3",
  "property_address_country": "CA",
  "property_address_county": "Oxford County",
  "property_neighborhood_address": "Southwest Ontario Area",
  "property_address_latitude": "43.1170616",
  "property_address_longitude": "-80.74981439999999",
  "property_email": null,
  "property_phone": "(226) 796-9530",
  "property_call_tracking_phone": null,
  "property_company_name": "Z Modular",
  "property_company_url": "https://www.z-modular.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern Woodstock apartments with room to do more.</strong> Studio, one- and two-bedroom homes pair open-concept design with stainless steel appliances, in-suite laundry, 9-foot ceilings, and thoughtful comfort features—plus useful community spaces when it’s time to get moving, unwind, or take in the view.</p>",
  "property_long_description": "<p><strong>Modern Woodstock apartments with room to do more.</strong> At FUZE Woodstock, you get sleek studio, one- and two-bedroom layouts in a Canadian-built community designed around everyday ease—open-concept homes with stainless steel appliances, in-suite laundry, premium wood-style flooring, 9-foot ceilings, extra sound proofing, and energy-efficient insulation that helps keep comfort up and utility costs down.</p><p>Step beyond your door to <a href=\"/amenities\">amenities</a> that feel genuinely useful: a 24-hour fitness centre, resident lounge with ping-pong and foosball, indoor bike storage, pet wash station, reserved parking, EV charging, and a rooftop lounge with kitchen, seasonal BBQ deck, and terrace seating for a better view of the city.</p><p>Your spot near Southside Park puts Woodstock’s largest park—trails, gardens, sports fields, skate park, and open green space—close by, with downtown, VIA Rail, Highway 401, shopping, coffee, and local favourites like Binh Thanh, Chiba Sushi, and Coffee Culture within easy reach. Explore available <a href=\"/floor-plans\">floor plans</a> or see more of the <a href=\"/neighborhood\">neighborhood</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-d77d-75cb-be3b-55ad3b06532a.webp",
  "property_featured_image_media": {
    "alt_text": "The community lounge features a ping pong table, foosball table, and comfortable seating area with a TV.",
    "public_id": "01a117c7-d77d-75cb-be3b-55ad3b06532a",
    "storage_key": "property/6767906449167809/01a117c7-d77d-75cb-be3b-55ad3b06532a.webp",
    "width": 1800,
    "height": 700
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167809/01a117e7-bfcf-7023-8d33-e460ba6dd1ba.mp4",
  "property_featured_video_media": {
    "public_id": "01a117e7-bfcf-7023-8d33-e460ba6dd1ba",
    "storage_key": "property/6767906449167809/01a117e7-bfcf-7023-8d33-e460ba6dd1ba.mp4",
    "thumbnail_key": "property/6767906449167809/01a117e7-bfcf-7023-8d33-e460ba6dd1ba_thumb.webp",
    "size_bytes": 8771884,
    "classification": "Community",
    "title": "Luxury Apartment Amenities & Features",
    "description": "Discover the exceptional amenities and interior features of our apartments, including a modern gym, stylish common areas, and well-appointed living spaces. Experience comfort and convenience."
  },
  "property_total_units": "103",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.2621359223301",
  "property_admin_fee": "200",
  "property_application_fee": null,
  "property_fees_deposit_info": "Security deposit: $300",
  "property_ispetfriendly": true,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "As permitted by Ontario law.",
  "property_pet_policy_description": "We welcome all your furry friends at FUZE Woodstock! As permitted by Ontario law.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-3be1-71ee-ad3e-abf1e7376722.webp",
  "property_primary_logo_media": {
    "alt_text": "Fuze Woodstock logo",
    "public_id": "01a117c7-3be1-71ee-ad3e-abf1e7376722",
    "storage_key": "property/6767906449167809/01a117c7-3be1-71ee-ad3e-abf1e7376722.webp",
    "width": 1132,
    "height": 122
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a13b45-d014-77db-b513-77721f51fa63.webp",
  "property_secondary_logo_media": {
    "alt_text": "Fuze Woodstock logo.",
    "public_id": "01a13b45-d014-77db-b513-77721f51fa63",
    "storage_key": "property/6767906449167809/01a13b45-d014-77db-b513-77721f51fa63.webp",
    "width": 454,
    "height": 292
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13b82-360e-700b-a136-440b6b7cfdcf.webp",
  "property_fav_icon_media": {
    "alt_text": "Red and brown Z logo",
    "public_id": "01a13b82-360e-700b-a136-440b6b7cfdcf",
    "storage_key": "company/5767906449162477/01a13b82-360e-700b-a136-440b6b7cfdcf.webp",
    "width": 1080,
    "height": 1080
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a16032-245f-7032-83d7-5c94ac9f4042.webp",
  "property_mono_white_logo_media": {
    "alt_text": "FUZE WOODSTOCK logo",
    "public_id": "01a16032-245f-7032-83d7-5c94ac9f4042",
    "storage_key": "property/6767906449167809/01a16032-245f-7032-83d7-5c94ac9f4042.webp",
    "width": 1132,
    "height": 122
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-9415-766c-9da4-78a155ddd668.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a117c7-9415-766c-9da4-78a155ddd668",
    "storage_key": "property/6767906449167809/01a117c7-9415-766c-9da4-78a155ddd668.webp",
    "width": 1132,
    "height": 122
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13b82-360e-700b-a136-440b6b7cfdcf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13aed-a1b4-75fa-8eea-2a352ae0cd0e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13aed-9f9c-7250-a571-60b30bf57b15.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13aed-a0ab-7569-bf2b-4298ffba6543.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#2a535e",
  "property_secondary_color": "#0f2c33",
  "property_font_color": null,
  "property_color_4": "#e51837",
  "property_color_3": "#ffffff",
  "property_color_5": "#231f20",
  "property_color_6": "#931903",
  "property_color_7": "#e51837",
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "317 - 827 sq ft",
  "property_sqft_min": "317",
  "property_sqft_max": "827",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/FUZEWoodstock",
  "property_instagram_url": "https://www.instagram.com/fuzewoodstock.ca/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJeV83uyIfLIgRtOBUalsVZ-Q",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to FUZE Woodstock",
  "property_home_romance_title": "Embrace the Joy of Living in Your Perfect Apartment",
  "property_home_amenities_blurb": "<p><strong>Amenities with everyday staying power.</strong> FUZE Woodstock brings the useful and the social together, from a 24-hour fitness centre to a rooftop lounge with kitchen and terrace. Indoors, a resident lounge with ping-pong and foosball adds an easy hangout option, while bike storage, reserved parking, in-suite laundry, stainless steel appliances, sound proofing, and pet-friendly conveniences keep daily life running smoothly.</p>",
  "property_home_floorplans_blurb": "<p><strong>Studio, one-bedroom, and two-bedroom layouts with room to choose.</strong> At FUZE Woodstock, floor plans pair open-concept living with modern kitchens, stainless steel appliances, in-suite laundry, high ceilings, and generous closet space. Select options include one or two baths, giving each apartment a polished, practical feel from day one.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture FUZE Woodstock in full detail.</strong> Preview bright interiors with floor-to-ceiling glass, airy light wood-style flooring, and sleek kitchens finished with dark cabinetry, white quartz counters, and subway tile. Then take a closer look at polished community spaces, from the wood-accented lounge and game tables to the fitness space and rooftop terrace made for open-air downtime.</p>",
  "property_home_neighborhood_blurb": "<p><strong>South Woodstock keeps everyday plans close and weekends flexible.</strong> From FUZE Woodstock, reach the Finkle Street recreation corridor, Southside Park, and nearby community facilities with ease. Downtown Woodstock adds Museum Square, the Woodstock Art Gallery, independent shops, Upper Thames Brewing, and Brickhouse Brewpub, while VIA Rail, Woodstock Transit, and Pittock Conservation Area keep more of the city within reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have a lot to love at FUZE Woodstock.</strong> Reviews highlight a clean, well-kept building, responsive management, and an easy move-in experience with Andrea and the team. Modern layouts, bright interiors, a tidy fitness room, inviting lounge spaces, and a rooftop patio add to the everyday appeal. See why one reviewer called it a <strong>“Beautiful place to live!”</strong></p>",
  "property_neighborhood_blurb": "<p><strong>South Woodstock puts practical days and easy detours close together.</strong> From FUZE Woodstock, you’re near the Finkle Street recreation corridor, where Southside Aquatic Centre, Reeves Community Complex, and Southside Park make it simple to trade errands for open space. Downtown adds a different rhythm: Museum Square, the Woodstock Art Gallery, independent shops, and local stops like Upper Thames Brewing and Brickhouse Brewpub bring history, culture, and good meals into the week.</p><p>When you want to go farther, VIA Rail, Woodstock Transit, and quick routes across the city keep the map useful, while Pittock Conservation Area gives you a bigger dose of trails and water nearby. Explore the neighborhood, then come back to the rooftop terrace, resident lounge, and modern comfort waiting at home. Ready to see how it connects? <a href=\"/schedule-a-tour\">Schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that earn their place in your routine.</strong> At FUZE Woodstock, the shared spaces are designed for how your day actually unfolds: a 24-hour fitness centre for flexible workouts, a rooftop lounge with kitchen and terrace for fresh-air downtime, and a resident lounge where ping-pong and foosball make staying in feel more social.</p><p>Practical details keep the experience easy, too, from indoor bike storage and reserved parking to pet-friendly conveniences like the wash station. Inside, energy-efficient insulation, extra sound proofing, in-suite laundry, stainless steel appliances, and key fob access add comfort without extra fuss. See how it all comes together in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to explore the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for FUZE Woodstock.</strong><br>Sleek studio, one- and two-bedroom apartments pair open-concept design with stainless steel appliances, in-suite laundry, 9-foot ceilings, extra sound proofing, and energy-efficient comfort. If this feels like the right fit, apply online and take the next step toward calling FUZE Woodstock home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The FUZE Woodstock leasing team is here to help you learn more about modern studio, one-, and two-bedroom apartments with open-concept layouts, in-suite laundry, and everyday comfort built in. Reach out today—we’ll help you find your way to 140 Ferguson Dr.</p>",
  "property_faqs_blurb": "<p><strong>Questions about FUZE Woodstock?</strong> Start here for quick answers on leasing, <a href=\"/floor-plans\">floor plans</a>, everyday features, and what living in this modern Woodstock community is like. If you need anything more specific, the <a href=\"/contact-us\">leasing team</a> is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Compare layouts with everyday function built in.</strong> FUZE Woodstock offers efficient studio, one-bedroom, and two-bedroom apartment floor plans, including options with one or two baths, so you can choose the amount of space and separation that suits how you use home. Open-concept living areas, modern kitchens with stainless steel appliances, in-suite laundry, high ceilings, and generous closet space help each layout feel polished and practical from move-in day.</p><p>As you browse availability, look beyond bedroom count: consider where you’ll set up your dining area, store gear, unwind after the day, or step out to the rooftop lounge when you want a change of scenery. View the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your preferred floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details that make FUZE Woodstock feel polished from every angle.</strong> Browse bright apartment interiors where floor-to-ceiling glass draws in the view, light wood-style flooring keeps the space airy, and sleek kitchens pair dark cabinetry with white quartz counters and subway tile.</p><p>The gallery also gives you a closer look at the everyday backdrops beyond your front door: a resident lounge with warm wood-slat accents, blue lounge seating, and game tables; a fitness space with clean lines and plenty of equipment; and a rooftop lounge where the kitchen and terrace set the scene for open-air downtime. Like what you see? Explore more <a href=\"/amenities\">community spaces</a>, compare <a href=\"/floor-plans\">studio, one-, and two-bedroom layouts</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the photos in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore FUZE Woodstock on the map.</strong> Browse available apartments, then see what surrounds your spot near Southside Park—from everyday shopping and coffee to downtown, VIA Rail, and Highway 401 access all within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living starts at the front door.</strong> At FUZE Woodstock, your pet has a place in the daily routine—from quick outdoor breaks to cleanup made easier with the on-site pet wash station. After rainy walks, muddy paws, or fresh-air time at nearby leash-free areas around Woodstock, you can rinse, reset, and get back to a home that feels polished without feeling fussy.</p><p>Choose a layout with the space and flow that suits how you live, then make the most of convenient community features designed to simplify apartment life with pets. Review the policy details on this page, then explore available homes or <strong>schedule a tour</strong> to see how pet-friendly living fits at FUZE.</p>",
  "property_referafriend_blurb": "<p><strong>Share the ease of FUZE Woodstock.</strong> If you love your open-concept home, in-suite laundry, sleek finishes, and useful spaces like the rooftop lounge and 24-hour fitness centre, invite a friend to discover it too. Send a referral and help them find more room to do more.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at FUZE Woodstock.</strong><br>Pay rent, submit maintenance requests, and manage your account in a few quick clicks—so you can get back to enjoying everyday ease in your modern Woodstock apartment.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend FUZE Woodstock.</strong> Reviews consistently point to the same everyday wins: a clean, well-maintained building, quick and helpful management, and common spaces that feel cared for. Residents praise Andrea and the team for making tours, paperwork, and move-in feel smooth, with maintenance handled efficiently when questions come up.</p><p>You’ll also hear about the details that make daily life easier—from modern apartment layouts and bright interiors to a clean fitness room, welcoming lounge areas, and a rooftop patio residents are excited to use. As one reviewer put it, it’s a <strong>“Beautiful place to live!”</strong> Read the full reviews below to get a real resident perspective on FUZE Woodstock.</p>",
  "property_created_at": "1791400273675",
  "property_scheduletour_blurb": "<p><strong>See everyday ease up close.</strong> Tour FUZE Woodstock and get a feel for sleek open-concept layouts, 9-foot ceilings, in-suite laundry, and thoughtful finishes built for comfort. Step inside, explore the shared spaces, and find the studio, one-, or two-bedroom apartment that fits what’s next.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon with next steps. In the meantime, picture modern studio, one-, and two-bedroom apartments with open-concept layouts, in-suite laundry, stainless steel appliances, and thoughtful comfort built in at FUZE Woodstock.</p>",
  "property_virtualtours_blurb": "<p><strong>Step into the Game Room before you arrive.</strong> FUZE Woodstock’s virtual tours let you move through the community game room at your own pace, so you can picture the space beyond still photos. Look around the open lounge layout, warm wood-slat accents, comfortable seating, TV area, ping-pong setup, and bright window-lined backdrop that make this shared space feel polished and easy to enjoy.</p><p>Use the walkthrough to check the flow, finishes, and details from wherever you are, then keep exploring with the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see more in person.</p>",
  "property_copyright": "2026 All Rights Reserved. FUZE Woodstock",
  "property_seo_title_home": "FUZE Woodstock |  Apartments in Woodstock, ON",
  "property_seo_description_home": "Discover FUZE Woodstock: stylish studios to spacious two-bedrooms, rooftop lounge, fitness center, and pet-friendly amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Woodstock, ON Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at FUZE Woodstock! Choose from studios to two-bedroom layouts in the heart of Woodstock, ON. Browse our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Woodstock, ON Apartments for Rent",
  "property_seo_description_amenities": "Experience FUZE Woodstock's vibrant community with fitness facilities, a rooftop lounge, and more. Your ideal studio or two-bedroom apartment awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Woodstock, ON",
  "property_seo_description_gallery": "Capture the essence of FUZE Woodstock with our stunning photo gallery! Picture your life in stylish studios, cozy one- and two-bedrooms, and vibrant amenities!",
  "property_seo_title_virtualtours": "Virtual Tours | FUZE Woodstock Apartments",
  "property_seo_description_virtualtours": "Experience FUZE Woodstock! Take a virtual tour of our stunning studio, one, and two-bedroom apartments in vibrant Woodstock, ON. See your future home today!",
  "property_seo_title_interactivemap": "Interactive Map | FUZE Woodstock Apartments",
  "property_seo_description_interactivemap": "Discover your ideal apartment at FUZE Woodstock! Explore modern designs, great amenities, and a vibrant community with our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Woodstock, ON",
  "property_seo_description_neighborhood": "Experience Woodstock living at FUZE! Enjoy local favorites and vibrant hotspots just steps from your stylish studio or one/two-bedroom home.",
  "property_seo_title_contact": "Contact Us | FUZE Woodstock",
  "property_seo_description_contact": "Connect with FUZE Woodstock in beautiful Woodstock, ON! Inquire about our stylish studio, 1, and 2-bedroom apartments for modern living!",
  "property_seo_title_faqs": "FAQs | Apartments in Woodstock, ON",
  "property_seo_description_faqs": "Get answers to your burning questions at FUZE Woodstock! Explore FAQs about our studio to two-bedroom apartments and top-notch amenities in Woodstock, ON.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Woodstock, ON",
  "property_seo_description_reviews": "Uncover the vibe at FUZE Woodstock! Our residents love the rooftop lounge, fitness center, and pet-friendly amenities. Read their reviews today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Woodstock, ON",
  "property_seo_description_applynow": "Find your perfect fit at FUZE Woodstock! Enjoy modern studios & spacious 1-2 bedroom apartments with top-notch amenities. Apply online for your new home today!",
  "property_seo_title_residentaccess": "Resident Access | FUZE Woodstock",
  "property_seo_description_residentaccess": "Unlock seamless living at FUZE Woodstock! Access your resident portal to pay rent, schedule maintenance, and stay connected to your community in Woodstock, ON.",
  "property_seo_title_referafriend": "Refer A Friend | FUZE Woodstock",
  "property_seo_description_referafriend": "Refer a friend to FUZE Woodstock and cultivate a vibrant community together! Great friends make the best neighbors—invite them to join your home today!",
  "property_seo_title_scheduletour": "Schedule a Tour | FUZE Woodstock",
  "property_seo_description_scheduletour": "Experience modern living at FUZE Woodstock! Schedule your tour today and discover your new home in the heart of Woodstock, ON—where comfort meets convenience.",
  "property_seo_title_privacy": "Privacy Policy | FUZE Woodstock",
  "property_seo_description_privacy": "Your privacy matters at FUZE Woodstock. Discover how we protect your information and secure your living experience. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | FUZE Woodstock",
  "property_seo_description_accessibility": "At FUZE Woodstock, we prioritize accessibility for all. Join our inclusive community in Woodstock, ON, and support digital inclusion!",
  "property_seo_title_sitemap": "Sitemap | FUZE Woodstock",
  "property_seo_description_sitemap": "Unlock the ultimate living experience at FUZE Woodstock! Navigate your way through our sitemap and discover every unparalleled amenity and feature we offer.",
  "property_seo_title_thankyou": "Thank You | FUZE Woodstock",
  "property_seo_description_thankyou": "Thank you for reaching out to FUZE Woodstock! Your inquiry is important to us. Expect a prompt follow-up from our team—exciting living awaits in Woodstock!",
  "property_seo_title_pets": "Pet Policy | Apartments in Woodstock, ON",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793725273385",
  "amenities": [
    {
      "id": "custom_8f260616-9a10-4244-b695-b9ab27c3b106",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved onsite parking",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee14cc73-a5bf-43e4-a2ac-5228b3b5e26f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "In-unit washer & dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_24f52a5a-eb76-4397-b99d-7c0967ace9a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_216dc25c-051d-4e47-b868-1a0c6e29cd93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Air conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17a09d83-8055-4864-8864-6f85eb8aea30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless steel appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_436017b7-c742-4f5e-b668-f199322a6817",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a810d7d-66de-4bd2-832a-4860c0696f32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Glass railing balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_07dfd5cf-679e-4b7c-b6f1-9a173fa9d111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Key fob lock technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fefeec43-fbcc-43ee-8db3-8a463f1709f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Roller blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26dd26db-6ff3-40f7-8bbd-2664b870fa81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Premium wood-style flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7a1ae24c-6520-44f5-8e18-bdc46e5bcda5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "9' ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9108e205-1ccd-4376-903d-7a9abe61f318",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Extra sound proofing for a peaceful living experience",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_574f76f7-8d79-4ed2-a0e4-e1506cfb2eb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "LED lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c2418a0-b929-4b77-9c14-b2af197c0053",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious closet space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81f802ee-d754-489e-8ff3-8ebe275f9d94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Rooftop lounge with kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a06c03c3-8f5c-4206-bdc1-dd348bd3dcd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Rooftop patio deck with BBQ (seasonal)",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aef643a1-b6cf-4370-9360-32cf277dbde2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "First floor resident TV lounge with ping-pong & foosball",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81f99b42-b4a7-4e2d-965b-194aa48d13c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Fully equipped fitness centre",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_522e9b16-566d-4706-b043-fbc849d1cbe2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Luxer One package system",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1bb16cd-4172-44ef-88d4-305257d69c74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Indoor pet wash & outdoor pet relief stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f14bbb5f-5864-4923-a184-ef40b131faf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Indoor bicycle storage room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7638263e-7c86-4025-bdf1-09251d99067d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Secured FOB system & digital keys",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0035f99a-b2d9-458d-985c-6098b8a92605",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Covered outdoor patio with ample seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aef9bf3a-3900-41ab-bcd9-c55ae6e219c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Electric vehicle charging stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab059b85-ff0d-4288-ab7e-f1dbb315580d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "external_id": "false",
      "title": "Canadian Built and owned",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_855b4a3a-8e01-4aff-b963-0726067ee2fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a14137-2b9b-73dd-997c-88b8d885dd83.webp",
      "image_media": {
        "alt_text": "Balcony view overlooking neighborhood with trees and buildings under a clear blue sky.",
        "public_id": "01a14137-2b9b-73dd-997c-88b8d885dd83",
        "storage_key": "property/6767906449167809/01a14137-2b9b-73dd-997c-88b8d885dd83.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the fresh air and scenic views from your private balcony, perfect for morning coffee or evening relaxation.",
      "link": "",
      "alt_text": "Balcony view overlooking neighborhood with trees and buildings under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4dc91a8c-d0c9-4960-814f-c99aa5823c43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117cb-47c8-71ee-9fa0-9a864c72ac62.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment hallway, showing a bathroom entrance and a glimpse of a bedroom.",
        "public_id": "01a117cb-47c8-71ee-9fa0-9a864c72ac62",
        "storage_key": "property/6767906449167809/01a117cb-47c8-71ee-9fa0-9a864c72ac62.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Step into your new home with this apartment hallway, featuring easy access to the bathroom and a cozy bedroom.",
      "link": "",
      "alt_text": "Interior view of an apartment hallway, showing a bathroom entrance and a glimpse of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_83eb4e70-5db5-4592-bd8d-8e57b6c6c2c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-eba9-7108-a5c8-10aee519ee63.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, elegant nightstands, and modern decor, opening to a living area and balcony.",
        "public_id": "01a117c7-eba9-7108-a5c8-10aee519ee63",
        "storage_key": "property/6767906449167809/01a117c7-eba9-7108-a5c8-10aee519ee63.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed apartment bedroom. Featuring a plush king-size bed, chic nightstands, and tasteful artwork, this space offers a serene retreat. Step out onto your private balcony to enjoy the fresh air and scenic views.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-size bed, elegant nightstands, and modern decor, opening to a living area and balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4d60f715-db8d-4067-9b03-128f69c03291",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-d511-76ed-bbe0-d8db815e9961.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with dark cabinets and appliances, and a stacked washer/dryer unit.",
        "public_id": "01a117c7-d511-76ed-bbe0-d8db815e9961",
        "storage_key": "property/6767906449167809/01a117c7-d511-76ed-bbe0-d8db815e9961.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious studio apartment featuring a modern kitchen with sleek dark cabinetry and stainless steel appliances, adjacent to a versatile living area. Includes an in-unit stacked washer/dryer for convenience.",
      "link": "",
      "alt_text": "Modern kitchen and living area with dark cabinets and appliances, and a stacked washer/dryer unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fe7e9471-0957-41b4-906d-605f57bead76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-d190-7239-b90c-42a540b48b1b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood flooring.",
        "public_id": "01a117c7-d190-7239-b90c-42a540b48b1b",
        "storage_key": "property/6767906449167809/01a117c7-d190-7239-b90c-42a540b48b1b.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring stainless steel appliances, ample cabinet space, and light wood flooring. Perfect for preparing meals and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and light wood flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3a663d42-dc14-4897-be4b-77cec642eeda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-d0cb-7252-9aba-21d74c90d76c.webp",
      "image_media": {
        "alt_text": "Interior view of a room with built-in shelves and a sliding glass door leading to a balcony, with a view of the surrounding neighborhood.",
        "public_id": "01a117c7-d0cb-7252-9aba-21d74c90d76c",
        "storage_key": "property/6767906449167809/01a117c7-d0cb-7252-9aba-21d74c90d76c.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious interior with ample storage thanks to built-in shelving. Large sliding glass doors open to a private balcony, offering a glimpse of the vibrant community outside.",
      "link": "",
      "alt_text": "Interior view of a room with built-in shelves and a sliding glass door leading to a balcony, with a view of the surrounding neighborhood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62509377-e463-4eaf-86f9-32b8cf4dc2e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-d067-75d8-b9e1-ee92737d67a4.webp",
      "image_media": {
        "alt_text": "Modern laundry room with stacked washer and dryer, and built-in cabinets.",
        "public_id": "01a117c7-d067-75d8-b9e1-ee92737d67a4",
        "storage_key": "property/6767906449167809/01a117c7-d067-75d8-b9e1-ee92737d67a4.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, complete with ample storage and sleek, modern design.",
      "link": "",
      "alt_text": "Modern laundry room with stacked washer and dryer, and built-in cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cedf5a4b-9555-4c99-b495-b51e66d0d611",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-cf21-77e8-b542-f384147f78b2.webp",
      "image_media": {
        "alt_text": "Modern apartment laundry room with washer and dryer",
        "public_id": "01a117c7-cf21-77e8-b542-f384147f78b2",
        "storage_key": "property/6767906449167809/01a117c7-cf21-77e8-b542-f384147f78b2.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious laundry room featuring a modern washer and dryer, ample cabinet storage, and sleek finishes for a clean and functional space.",
      "link": "",
      "alt_text": "Modern apartment laundry room with washer and dryer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e5af9ff-3d6b-4771-9942-3943aee762d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-cecc-74e1-a4e8-8e8d6a45b7e7.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with large windows overlooking the city.",
        "public_id": "01a117c7-cecc-74e1-a4e8-8e8d6a45b7e7",
        "storage_key": "property/6767906449167809/01a117c7-cecc-74e1-a4e8-8e8d6a45b7e7.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment living area featuring a sleek kitchen with dark cabinetry and stainless steel appliances, bathed in natural light from large windows.",
      "link": "",
      "alt_text": "Modern kitchen and living area with large windows overlooking the city.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_68d2bbae-6e8e-4af4-ad42-ead6dd9533e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-cb45-73e2-8830-aa643cee8383.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and shower with a striped curtain.",
        "public_id": "01a117c7-cb45-73e2-8830-aa643cee8383",
        "storage_key": "property/6767906449167809/01a117c7-cb45-73e2-8830-aa643cee8383.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Elegant and functional bathroom featuring a sleek vanity with a white countertop, a modern toilet, and a shower enclosed by a stylish striped curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and shower with a striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19224338-d71d-4ce5-a4d4-395e6a436148",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-ca3d-70b6-bf08-aafa3903171a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, white subway tile backsplash, stainless steel appliances, and a laundry area.",
        "public_id": "01a117c7-ca3d-70b6-bf08-aafa3903171a",
        "storage_key": "property/6767906449167809/01a117c7-ca3d-70b6-bf08-aafa3903171a.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Discover the perfect blend of style and functionality in this modern apartment kitchen, featuring sleek dark cabinetry, subway tile, and essential appliances including a washer and dryer.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, white subway tile backsplash, stainless steel appliances, and a laundry area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4075ca47-239e-4c94-929d-275e9f447a71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-c5af-70cc-b65f-ac74ea47eba3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, shower, and a glimpse into the bedroom.",
        "public_id": "01a117c7-c5af-70cc-b65f-ac74ea47eba3",
        "storage_key": "property/6767906449167809/01a117c7-c5af-70cc-b65f-ac74ea47eba3.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Step into this chic bathroom featuring a sleek vanity and a refreshing shower. Adjacent, discover a cozy bedroom, offering a complete living experience.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, shower, and a glimpse into the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_494af416-dd7d-47a7-a7b0-0b653512b924",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-c547-73dd-8918-a49849ab82c6.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment hallway with a glimpse into the bathroom and bedroom, and the kitchen area.",
        "public_id": "01a117c7-c547-73dd-8918-a49849ab82c6",
        "storage_key": "property/6767906449167809/01a117c7-c547-73dd-8918-a49849ab82c6.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Step into a bright and airy apartment featuring a sleek hallway connecting the bathroom, bedroom, and a modern kitchen area, offering comfortable and stylish living.",
      "link": "",
      "alt_text": "Interior view of a modern apartment hallway with a glimpse into the bathroom and bedroom, and the kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13778bbc-a7a7-4fd1-b647-099dcd69e3f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-bf4e-744b-bab4-67848b3d223c.webp",
      "image_media": {
        "alt_text": "Modern bedroom with mirrored closet doors reflecting a tidy bed and a glimpse of a bathroom.",
        "public_id": "01a117c7-bf4e-744b-bab4-67848b3d223c",
        "storage_key": "property/6767906449167809/01a117c7-bf4e-744b-bab4-67848b3d223c.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "A serene bedroom featuring mirrored closet doors that open up to reveal a comfortable sleeping area and a peek into a clean, well-appointed bathroom.",
      "link": "",
      "alt_text": "Modern bedroom with mirrored closet doors reflecting a tidy bed and a glimpse of a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4bf6920e-6536-40cc-9733-078c8028b06c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-be12-729e-a4e3-ed1322d08ddb.webp",
      "image_media": {
        "alt_text": "Bedroom with king-sized bed and mirrored closet doors, adjacent to a dining area with balcony.",
        "public_id": "01a117c7-be12-729e-a4e3-ed1322d08ddb",
        "storage_key": "property/6767906449167809/01a117c7-be12-729e-a4e3-ed1322d08ddb.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a comfortable king-sized bed, complemented by mirrored closet doors that reflect the room's natural light. Adjacent to the bedroom is a chic dining area with a modern table and chairs, offering access to a private balcony with city views.",
      "link": "",
      "alt_text": "Bedroom with king-sized bed and mirrored closet doors, adjacent to a dining area with balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b79d3a0c-3b1a-4b29-b6bf-2cf301b6916f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-b87a-7410-91b6-fb4b965907aa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, white subway tile backsplash, stainless steel appliances, and a dining nook.",
        "public_id": "01a117c7-b87a-7410-91b6-fb4b965907aa",
        "storage_key": "property/6767906449167809/01a117c7-b87a-7410-91b6-fb4b965907aa.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Discover the sleek design of our modern kitchens, featuring dark cabinetry, pristine white subway tile backsplashes, and top-of-the-line stainless steel appliances. Enjoy a bright dining nook perfect for morning coffee.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, white subway tile backsplash, stainless steel appliances, and a dining nook.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cace488c-4029-4ced-9ba7-7f9257a5fb43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-b749-7567-9017-66ad5b63fda2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinetry and white subway tile backsplash.",
        "public_id": "01a117c7-b749-7567-9017-66ad5b63fda2",
        "storage_key": "property/6767906449167809/01a117c7-b749-7567-9017-66ad5b63fda2.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Experience culinary convenience in this sleek, modern kitchen featuring dark cabinetry, stainless steel appliances, and a subway tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinetry and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7c46f66-2024-47ea-be48-c45eaf9fd9b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-b66f-77ec-888a-2bbea7d33ef7.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with sleek black cabinets and a white table.",
        "public_id": "01a117c7-b66f-77ec-888a-2bbea7d33ef7",
        "storage_key": "property/6767906449167809/01a117c7-b66f-77ec-888a-2bbea7d33ef7.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed apartment featuring a modern kitchen with ample cabinet space and a bright, open dining area perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and dining area with sleek black cabinets and a white table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_efbace2e-c9e6-4d68-a838-d8bc32727ff5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-b7e1-70c9-942a-0167d2deb8a5.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed and a view into the bathroom with a vanity and toilet.",
        "public_id": "01a117c7-b7e1-70c9-942a-0167d2deb8a5",
        "storage_key": "property/6767906449167809/01a117c7-b7e1-70c9-942a-0167d2deb8a5.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable king-size bed, modern artwork, and a peek into the en-suite bathroom with a sleek vanity and toilet.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed and a view into the bathroom with a vanity and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a2ff090-ffd5-4be2-a18d-97ef5042891f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-b3db-71ea-8f97-d1537ad297d5.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment with a desk.",
        "public_id": "01a117c7-b3db-71ea-8f97-d1537ad297d5",
        "storage_key": "property/6767906449167809/01a117c7-b3db-71ea-8f97-d1537ad297d5.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Stylish dining area and modern kitchen with a built-in desk. Perfect for entertaining or quiet work.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment with a desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5da07709-ec0b-42ec-a52c-df5485090741",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-b002-7761-8ab8-0781cd8097c5.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with sleek dark cabinetry, a dining table, and a comfortable sofa.",
        "public_id": "01a117c7-b002-7761-8ab8-0781cd8097c5",
        "storage_key": "property/6767906449167809/01a117c7-b002-7761-8ab8-0781cd8097c5.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment featuring a spacious living area, a modern kitchen, and a dining nook. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern living room and kitchen with sleek dark cabinetry, a dining table, and a comfortable sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa910407-ebb5-4484-ab74-84dc5b48c15f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-af8f-7664-a5c6-a5a41dd2f3c0.webp",
      "image_media": {
        "alt_text": "Dining area with a round table set for four, adjacent to a living room and bedroom.",
        "public_id": "01a117c7-af8f-7664-a5c6-a5a41dd2f3c0",
        "storage_key": "property/6767906449167809/01a117c7-af8f-7664-a5c6-a5a41dd2f3c0.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Step into comfort with this stylish dining area, perfect for intimate meals or entertaining guests. Enjoy the open-concept flow into the living room and private bedroom.",
      "link": "",
      "alt_text": "Dining area with a round table set for four, adjacent to a living room and bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_400c0e10-78e0-401e-bf19-6fefcefc698e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-ad88-7203-b120-3e97f276fd51.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black cabinets and white subway tile backsplash",
        "public_id": "01a117c7-ad88-7203-b120-3e97f276fd51",
        "storage_key": "property/6767906449167809/01a117c7-ad88-7203-b120-3e97f276fd51.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek modern kitchen, featuring black cabinetry, stainless steel appliances, and a white subway tile backsplash. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with black cabinets and white subway tile backsplash",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e55abb92-a10a-4406-8b45-22a8bf5fbe2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-ab84-76e3-ad2f-e0826a0460fe.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white subway tile shower and vanity.",
        "public_id": "01a117c7-ab84-76e3-ad2f-e0826a0460fe",
        "storage_key": "property/6767906449167809/01a117c7-ab84-76e3-ad2f-e0826a0460fe.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a sleek vanity and a pristine white subway tile shower/tub combo. A touch of modern elegance for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with white subway tile shower and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_952c6eb5-2caf-4e8e-a19d-6fb9e00efa76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-9c37-74d6-84bb-71a19dd1bd16.webp",
      "image_media": {
        "alt_text": "Luxer One package lockers and Canada Post mailroom",
        "public_id": "01a17893-9c37-74d6-84bb-71a19dd1bd16",
        "storage_key": "property/6767906449167809/01a17893-9c37-74d6-84bb-71a19dd1bd16.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Secure and convenient Luxer One package lockers and a dedicated Canada Post mailroom for residents.",
      "link": "",
      "alt_text": "Luxer One package lockers and Canada Post mailroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b3c8590-c103-4f3b-b214-31adec9668a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-97fc-7765-8e00-d850236f1abf.webp",
      "image_media": {
        "alt_text": "Outdoor rooftop patio with dining tables, bar seating, lounge chairs, and grills.",
        "public_id": "01a17893-97fc-7765-8e00-d850236f1abf",
        "storage_key": "property/6767906449167809/01a17893-97fc-7765-8e00-d850236f1abf.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy outdoor living on our spacious rooftop patio, complete with comfortable seating, dining areas, and barbecue grills for perfect gatherings.",
      "link": "",
      "alt_text": "Outdoor rooftop patio with dining tables, bar seating, lounge chairs, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e911b908-16b4-4471-a44a-b04a2b1f1937",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-98b1-7428-82e3-3879fac3bf12.webp",
      "image_media": {
        "alt_text": "Rooftop patio with lounge seating, dining tables, umbrellas, and outdoor chairs.",
        "public_id": "01a17893-98b1-7428-82e3-3879fac3bf12",
        "storage_key": "property/6767906449167809/01a17893-98b1-7428-82e3-3879fac3bf12.webp",
        "width": 1380,
        "height": 537
      },
      "title": "Community",
      "description": "Enjoy the outdoors on our spacious rooftop patio, complete with comfortable lounge seating, dining tables for al fresco meals, and umbrellas for shade.",
      "link": "",
      "alt_text": "Rooftop patio with lounge seating, dining tables, umbrellas, and outdoor chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9772bf3c-d427-4079-8234-3b3268ce7e6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-8156-72c3-9f39-4483e435094b.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with balconies, a covered outdoor seating area, and parking.",
        "public_id": "01a17893-8156-72c3-9f39-4483e435094b",
        "storage_key": "property/6767906449167809/01a17893-8156-72c3-9f39-4483e435094b.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring private balconies, a vibrant orange overhang with picnic tables, and convenient on-site parking.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with balconies, a covered outdoor seating area, and parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60ded525-712f-4744-a4d8-d5b56c1dd3aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-81ff-7668-b03b-c4878a602b55.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multifamily building with balconies and surrounding parkland.",
        "public_id": "01a17893-81ff-7668-b03b-c4878a602b55",
        "storage_key": "property/6767906449167809/01a17893-81ff-7668-b03b-c4878a602b55.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Discover modern living in this striking multifamily building, featuring sleek balconies and an amenity-rich community setting with nearby park access.",
      "link": "",
      "alt_text": "Exterior view of a modern multifamily building with balconies and surrounding parkland.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44c54640-72c7-44d1-ac9d-b97cf5a0bfa5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-82ea-7621-aaaa-057ead4e9ce8.webp",
      "image_media": {
        "alt_text": "Rooftop terrace with outdoor seating and dining areas overlooking a city skyline at sunset.",
        "public_id": "01a17893-82ea-7621-aaaa-057ead4e9ce8",
        "storage_key": "property/6767906449167809/01a17893-82ea-7621-aaaa-057ead4e9ce8.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy breathtaking sunsets and city views from our exclusive rooftop terrace, featuring comfortable lounge seating and dining areas perfect for entertaining.",
      "link": "",
      "alt_text": "Rooftop terrace with outdoor seating and dining areas overlooking a city skyline at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0fa2e57-b521-46a1-a404-4382f29ce758",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-8223-71ca-ab01-9cdf157ca9c4.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with parking lot and green space.",
        "public_id": "01a17893-8223-71ca-ab01-9cdf157ca9c4",
        "storage_key": "property/6767906449167809/01a17893-8223-71ca-ab01-9cdf157ca9c4.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Showcasing the modern architecture of the apartment building, its convenient parking, and the surrounding green spaces.",
      "link": "",
      "alt_text": "Modern apartment building exterior with parking lot and green space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bf8e277d-41a8-4006-a405-83872bf0159f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-7a4d-7233-b2c7-a601b2386abc.webp",
      "image_media": {
        "alt_text": "Exterior building signage for FUZE Woodstock at 140 Ferguson Dr.",
        "public_id": "01a17893-7a4d-7233-b2c7-a601b2386abc",
        "storage_key": "property/6767906449167809/01a17893-7a4d-7233-b2c7-a601b2386abc.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Welcome to FUZE Woodstock, located at 140 Ferguson Drive. This exterior signage welcomes residents and visitors to the property.",
      "link": "",
      "alt_text": "Exterior building signage for FUZE Woodstock at 140 Ferguson Dr.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f4cfb8f0-e791-4b45-b900-3ab5b305881d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-7c91-770d-82bd-0d32030cd48e.webp",
      "image_media": {
        "alt_text": "Rooftop patio with outdoor dining tables, umbrellas, lounge seating, and a grill.",
        "public_id": "01a17893-7c91-770d-82bd-0d32030cd48e",
        "storage_key": "property/6767906449167809/01a17893-7c91-770d-82bd-0d32030cd48e.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and relaxation on our spacious rooftop patio, complete with comfortable seating, umbrellas for shade, and a barbecue grill for your convenience.",
      "link": "",
      "alt_text": "Rooftop patio with outdoor dining tables, umbrellas, lounge seating, and a grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f96a44ed-c7ef-4ca4-852a-472eb4b670af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-7cf9-766e-86cd-4940278a1a48.webp",
      "image_media": {
        "alt_text": "FUZE Woodstock apartment building exterior and monument sign.",
        "public_id": "01a17893-7cf9-766e-86cd-4940278a1a48",
        "storage_key": "property/6767906449167809/01a17893-7cf9-766e-86cd-4940278a1a48.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Welcome to FUZE Woodstock, a modern apartment community located at 140 Ferguson Drive. Enjoy our beautifully designed building and convenient location.",
      "link": "",
      "alt_text": "FUZE Woodstock apartment building exterior and monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_335bb24b-b7fc-49d8-b8a1-9a11b83df5ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-7b85-7424-93fc-b89a449a5491.webp",
      "image_media": {
        "alt_text": "Building exterior with entrance and signage at 140 Ferguson Drive.",
        "public_id": "01a17893-7b85-7424-93fc-b89a449a5491",
        "storage_key": "property/6767906449167809/01a17893-7b85-7424-93fc-b89a449a5491.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring a bright orange overhang with the address \"140 Ferguson Drive\" and bike racks. Includes an inviting entrance and outdoor seating area.",
      "link": "",
      "alt_text": "Building exterior with entrance and signage at 140 Ferguson Drive.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38cf7f1f-6f3a-46d8-b481-9139609d2507",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a17893-7c2c-76a5-bbaf-bce5647c4f7d.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and parking lot at sunset.",
        "public_id": "01a17893-7c2c-76a5-bbaf-bce5647c4f7d",
        "storage_key": "property/6767906449167809/01a17893-7c2c-76a5-bbaf-bce5647c4f7d.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Experience modern living in this striking apartment building, featuring sleek architecture and ample parking. Enjoy the vibrant atmosphere and convenient amenities.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and parking lot at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eeaa9654-8aa9-4272-8a36-64f923692625",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a14137-c646-77e0-a914-a8235d8e93af.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a large wooden dining table, chairs, and a wet bar.",
        "public_id": "01a14137-c646-77e0-a914-a8235d8e93af",
        "storage_key": "property/6767906449167809/01a14137-c646-77e0-a914-a8235d8e93af.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy gathering in our stylish community lounge, featuring a large dining table, comfortable seating, and a convenient wet bar area.",
      "link": "",
      "alt_text": "Modern community lounge with a large wooden dining table, chairs, and a wet bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b6025c70-8cea-44ff-be47-88ef1060a70b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a14137-c56f-76ab-9065-6b15b979d4a0.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio machines, weight benches, and free weights.",
        "public_id": "01a14137-c56f-76ab-9065-6b15b979d4a0",
        "storage_key": "property/6767906449167809/01a14137-c56f-76ab-9065-6b15b979d4a0.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, weight benches, and a variety of free weights.",
      "link": "",
      "alt_text": "Modern gym with cardio machines, weight benches, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_09d9d61b-05e5-4c67-a5d2-69185e74f59f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a14137-b6d4-74fc-abf8-111adace5f60.webp",
      "image_media": {
        "alt_text": "Communal dining area and kitchen with bar seating overlooking the city",
        "public_id": "01a14137-b6d4-74fc-abf8-111adace5f60",
        "storage_key": "property/6767906449167809/01a14137-b6d4-74fc-abf8-111adace5f60.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in the stylish communal dining area, complete with a modern kitchen and bar seating. Enjoy the city views from this vibrant social hub.",
      "link": "",
      "alt_text": "Communal dining area and kitchen with bar seating overlooking the city",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d95ad448-9547-4605-baef-0a12c6450806",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a14137-7b89-71ea-8314-289565d91651.webp",
      "image_media": {
        "alt_text": "Modern lounge area with large sectional sofa, armchairs, and coffee table, featuring large windows with a snowy view.",
        "public_id": "01a14137-7b89-71ea-8314-289565d91651",
        "storage_key": "property/6767906449167809/01a14137-7b89-71ea-8314-289565d91651.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, complete with comfortable seating and abundant natural light. Perfect for unwinding or connecting with neighbors.",
      "link": "",
      "alt_text": "Modern lounge area with large sectional sofa, armchairs, and coffee table, featuring large windows with a snowy view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_90ec145b-d182-4287-9590-d2b341dd756d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a14137-779c-77cc-ad8b-1f21f706de5c.webp",
      "image_media": {
        "alt_text": "Modern community lounge with ping pong table, foosball table, and comfortable seating.",
        "public_id": "01a14137-779c-77cc-ad8b-1f21f706de5c",
        "storage_key": "property/6767906449167809/01a14137-779c-77cc-ad8b-1f21f706de5c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a game of ping pong or foosball in our vibrant community lounge, complete with ample seating and entertainment options.",
      "link": "",
      "alt_text": "Modern community lounge with ping pong table, foosball table, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_def5af37-8aba-4238-aa42-eece62828a45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a14137-7587-72da-b808-c9f3d6774205.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, weight machines, dumbbells, and exercise balls.",
        "public_id": "01a14137-7587-72da-b808-c9f3d6774205",
        "storage_key": "property/6767906449167809/01a14137-7587-72da-b808-c9f3d6774205.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and weight training equipment, plus free weights and stability balls.",
      "link": "",
      "alt_text": "Well-equipped fitness center with cardio machines, weight machines, dumbbells, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72077881-41f4-4d0f-b2ba-0fc39b86410e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-cc84-763a-a625-a0d362e1f153.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and adjacent bathroom.",
        "public_id": "01a117c7-cc84-763a-a625-a0d362e1f153",
        "storage_key": "property/6767906449167809/01a117c7-cc84-763a-a625-a0d362e1f153.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a queen-size bed, modern nightstands, and a view into the en-suite bathroom featuring a vanity and toilet.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed and adjacent bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a6c4bf7e-2275-4a3c-a824-d88bb5428401",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Early Bird Coffee",
      "poi_type": "Restaurants",
      "poi_address": "375 Dundas St, Woodstock, ON N4S 1B6, Canada",
      "poi_short_description": "Welcoming local cafe serving house-roasted coffee and fresh baked goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-6da8-738c-8dec-f8fc71d11377.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-6da8-738c-8dec-f8fc71d11377",
        "storage_key": "property/6767906449167809/01a117c9-6da8-738c-8dec-f8fc71d11377.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://earlybirdcoffee.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1076649785153546008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "early-bird-coffee",
      "poi_latitude": "43.1296734",
      "poi_longitude": "-80.7612134",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-532-3127",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a43e-779d-ab76-4d87cf887a2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a43e-779d-ab76-4d87cf887a2a",
        "storage_key": "property/6767906449167809/01a117c9-a43e-779d-ab76-4d87cf887a2a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ9Vfb5LYfLIgRGOeTd0YH8Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_e30f3d68-d8fb-4c8c-8a1a-61bb414692d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Jesse's Breakfast (served all day) & Lunch",
      "poi_type": "Restaurants",
      "poi_address": "681 Dundas St, Woodstock, ON N4S 1E3, Canada",
      "poi_short_description": "Family-friendly breakfast and lunch spot serving all-day breakfast classics and hearty portions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-6b71-75ea-a12b-f3fbef8ea13d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-6b71-75ea-a12b-f3fbef8ea13d",
        "storage_key": "property/6767906449167809/01a117c9-6b71-75ea-a12b-f3fbef8ea13d.webp",
        "width": 1280,
        "height": 956
      },
      "poi_business_url": "http://www.jesseswoodstock.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18189253135508056553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jesses-breakfast-served-all-day--lunch",
      "poi_latitude": "43.1315409",
      "poi_longitude": "-80.7479182",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-421-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuYyuZxQfLIgR6SmeH1s1bfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b923d7c0-0b83-4d8e-9898-1573b9bdfd0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Sunset Grill",
      "poi_type": "Restaurants",
      "poi_address": "547 Norwich Ave, Woodstock, ON N4V 1C7, Canada",
      "poi_short_description": "Welcoming breakfast restaurant serving fresh made-to-order eggs, omelettes, and pancakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-6bda-7719-bf9b-6e2364958150.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-6bda-7719-bf9b-6e2364958150",
        "storage_key": "property/6767906449167809/01a117c9-6bda-7719-bf9b-6e2364958150.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.sunsetgrill.ca/restaurant/woodstock-norwich/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12991883366789527503&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunset-grill",
      "poi_latitude": "43.1128845",
      "poi_longitude": "-80.7353897",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-421-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHembFc4fLIgRz7fLkBZxTLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_9c5f907a-a121-4b4c-97e6-c85f7d79c1e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Cheesy Cow Company",
      "poi_type": "Shopping & Retail",
      "poi_address": "521 Dundas St, Woodstock, ON N4S 1C3, Canada",
      "poi_short_description": "Welcoming cheese boutique serving gourmet grilled cheese and artisan charcuterie boards.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-6da0-7619-aff3-10aec2c033d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-6da0-7619-aff3-10aec2c033d7",
        "storage_key": "property/6767906449167809/01a117c9-6da0-7619-aff3-10aec2c033d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cheesycow.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5622572212459363111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheesy-cow-company",
      "poi_latitude": "43.1304105",
      "poi_longitude": "-80.75546620000001",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-788-7058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-a8646b4e15b9",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFQi8inMfLIgRJ1ufN6NjB04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_store"
    },
    {
      "id": "custom_fa8d648b-be69-4028-b5c1-39e9104674c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Sushi Cove",
      "poi_type": "Restaurants",
      "poi_address": "930 Dundas St #5, Woodstock, ON N4S 8X6, Canada",
      "poi_short_description": "Unassuming restaurant serving up familiar sushi rolls, udon soups & Korean dishes such as bibimbap.",
      "poi_long_description": "Unassuming restaurant serving up familiar sushi rolls, udon soups & Korean dishes such as bibimbap.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-6cc9-70a5-b091-77075de2172f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-6cc9-70a5-b091-77075de2172f",
        "storage_key": "property/6767906449167809/01a117c9-6cc9-70a5-b091-77075de2172f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sushicove.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2837741851308434018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-cove",
      "poi_latitude": "43.132627",
      "poi_longitude": "-80.7334211",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 519-290-2683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtesoFTofLIgRYqJ_wy2vYSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_fd098ef9-7e84-435b-a2cc-6684bfb272ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Crispy's Fish & Chips",
      "poi_type": "Restaurants",
      "poi_address": "194 Springbank Ave N, Woodstock, ON N4S 7R3, Canada",
      "poi_short_description": "Local fish and chips restaurant serving crispy battered fish including halibut and perch.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7538-760c-a62f-58264ed700ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7538-760c-a62f-58264ed700ac",
        "storage_key": "property/6767906449167809/01a117c9-7538-760c-a62f-58264ed700ac.webp",
        "width": 1280,
        "height": 810
      },
      "poi_business_url": "https://crispysfishandchips.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9071984084374394999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crispys-fish--chips",
      "poi_latitude": "43.1414909",
      "poi_longitude": "-80.7320901",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 519-290-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06br_iUfLIgRdxgilXUp5n0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fish_and_chips_restaurant"
    },
    {
      "id": "custom_054c18bb-24e8-48b5-8f37-b7139c2ae17b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Finkle Street Dining",
      "poi_type": "Restaurants",
      "poi_address": "450 Simcoe St, Woodstock, ON N4S 1J8, Canada",
      "poi_short_description": "Relaxed bar & grill with a warm vibe turning out global comfort fare, cocktails & local craft beer.",
      "poi_long_description": "Relaxed bar & grill with a warm vibe turning out global comfort fare, cocktails & local craft beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c6-f399-74f9-ba6a-a2498a52084a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c6-f399-74f9-ba6a-a2498a52084a",
        "storage_key": "property/6767906449167809/01a117c6-f399-74f9-ba6a-a2498a52084a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://finklestreet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4651968751939053349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "finkle-street-dining",
      "poi_latitude": "43.1286863",
      "poi_longitude": "-80.7577024",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-290-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm0P9KHMfLIgRJWeLxe4cj0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5f1b6f18-27d2-4703-b0c6-f423b89a5a54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Charles Dickens Pub",
      "poi_type": "Restaurants",
      "poi_address": "505 Dundas St, Woodstock, ON N4S 1C4, Canada",
      "poi_short_description": "British-themed watering hole with English pub favorites like fish 'n' chips, pies & meatloaf.",
      "poi_long_description": "British-themed watering hole with English pub favorites like fish 'n' chips, pies & meatloaf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-6d96-71aa-b357-6cbd251ee344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-6d96-71aa-b357-6cbd251ee344",
        "storage_key": "property/6767906449167809/01a117c9-6d96-71aa-b357-6cbd251ee344.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.charlesdickenspub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14063430357625145281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charles-dickens-pub",
      "poi_latitude": "43.1303369",
      "poi_longitude": "-80.75604349999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-421-2218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl9X1Pw0fLIgRwQexJWZXK8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b4bf20dc-f18d-4f47-abf7-cbd763f5ffbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Sixthirtynine",
      "poi_type": "Restaurants",
      "poi_address": "639 Peel St, Woodstock, ON N4S 1K9, Canada",
      "poi_short_description": "Modern, cozy restaurant offering upscale New Canadian eats, plus a chef's table & tasting menu.",
      "poi_long_description": "Modern, cozy restaurant offering upscale New Canadian eats, plus a chef's table & tasting menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-72a4-73cd-907f-c0d120fcf422.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-72a4-73cd-907f-c0d120fcf422",
        "storage_key": "property/6767906449167809/01a117c9-72a4-73cd-907f-c0d120fcf422.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://www.sixthirtynine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3453242891085257439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sixthirtynine",
      "poi_latitude": "43.130283",
      "poi_longitude": "-80.750044",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-536-9602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzx2NZRMfLIgR35pHBh1i7C8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_75e7918e-671a-4dc3-af9f-6e4f998fb54f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Brickhouse Brewpub",
      "poi_type": "Restaurants",
      "poi_address": "190 Fairway Rd, Woodstock, ON N4T 1W3, Canada",
      "poi_short_description": "Casual brewpub featuring extensive Ontario craft beer and classic pub fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c6-f20d-76be-bbc3-b5b285684cab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c6-f20d-76be-bbc3-b5b285684cab",
        "storage_key": "property/6767906449167809/01a117c6-f20d-76be-bbc3-b5b285684cab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://upperthamesbrewing.ca/brickhouse-brewpub/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7270129669981650253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brickhouse-brewpub",
      "poi_latitude": "43.147027099999995",
      "poi_longitude": "-80.7698097",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 519-290-5347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQykIlwofLIgRTb1Igmqw5GQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_31f63321-a6bd-4520-a3b3-ef8d5fe5acb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "IRONWORKS kitchen",
      "poi_type": "Restaurants",
      "poi_address": "529 Dundas St, Woodstock, ON N4S 1C3, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7122-767d-b802-dbaffb3db936.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7122-767d-b802-dbaffb3db936",
        "storage_key": "property/6767906449167809/01a117c9-7122-767d-b802-dbaffb3db936.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=386748106984391601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ironworks-kitchen",
      "poi_latitude": "43.1304995",
      "poi_longitude": "-80.75519589999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-290-0926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dM0WUIfLIgRsQNcrloBXgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_464b39d9-5971-4719-b1d4-bb337c89810e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Tandoori Knight",
      "poi_type": "Restaurants",
      "poi_address": "511 Dundas St, Woodstock, ON N4S 1C3, Canada",
      "poi_short_description": "An array of traditional Indian dishes with drinks in a space with warm lighting & booth seating.",
      "poi_long_description": "An array of traditional Indian dishes with drinks in a space with warm lighting & booth seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7115-736a-bd73-32e278ac2dbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7115-736a-bd73-32e278ac2dbe",
        "storage_key": "property/6767906449167809/01a117c9-7115-736a-bd73-32e278ac2dbe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tandooriknight.ca/menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=11441002676893015173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tandoori-knight",
      "poi_latitude": "43.1303961",
      "poi_longitude": "-80.7558336",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-290-9020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJydeVQQ0fLIgRhVyATlGbxp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_30f8723f-d797-4d59-b124-dda6597a81aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Swiss Chalet",
      "poi_type": "Restaurants",
      "poi_address": "427 Norwich Ave, Woodstock, ON N4S 3W4, Canada",
      "poi_short_description": "Iconic Canadian restaurant serving rotisserie chicken and signature chalet sauce.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7518-739e-84fd-0751e5da1295.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7518-739e-84fd-0751e5da1295",
        "storage_key": "property/6767906449167809/01a117c9-7518-739e-84fd-0751e5da1295.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.swisschalet.com/en/locations/on/woodstock/427-norwich-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=11196772392186965329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swiss-chalet",
      "poi_latitude": "43.1180907",
      "poi_longitude": "-80.7381472",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-539-9881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa35_nRMfLIgRUW006yrtYps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e26a90ef-771b-4935-9757-c8a6ebceec0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Boston Pizza",
      "poi_type": "Restaurants",
      "poi_address": "431 Norwich Ave, Woodstock, ON N4S 3W4, Canada",
      "poi_short_description": "Casual pizza restaurant serving gourmet pizzas, pasta, and varied appetizers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-77ca-71a8-b9f2-e22572da03c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-77ca-71a8-b9f2-e22572da03c3",
        "storage_key": "property/6767906449167809/01a117c9-77ca-71a8-b9f2-e22572da03c3.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://bostonpizza.com/en/locations/woodstock.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14490877924734380898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boston-pizza",
      "poi_latitude": "43.1176725",
      "poi_longitude": "-80.7381149",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-536-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi4JyplwfLIgRYqtXU7LwGck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_7f6a1df7-5c64-4c6e-a0b4-ac3be8bdf82f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Denny's",
      "poi_type": "Restaurants",
      "poi_address": "1506 Dundas St, Woodstock, ON N4S 7V9, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7821-74c5-ab02-9ed9289fe928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7821-74c5-ab02-9ed9289fe928",
        "storage_key": "property/6767906449167809/01a117c9-7821-74c5-ab02-9ed9289fe928.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7067825618849585560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dennys",
      "poi_latitude": "43.137540099999995",
      "poi_longitude": "-80.70167049999999",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2888-74cb-b60c-241ee05c20ba",
        "storage_key": "property/6767906449167809/01a117c7-2888-74cb-b60c-241ee05c20ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbRk7FwAZLIgRmFnvEfT1FWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_74832fe5-6b34-4ecf-81da-5d2de1ca39a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Foodland - Woodstock",
      "poi_type": "Shopping & Retail",
      "poi_address": "645 Dundas St, Woodstock, ON N4S 1E4, Canada",
      "poi_short_description": "Neighborhood supermarket featuring farm-fresh produce and an in-house bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-79bc-76a3-8727-1508a5cff7e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-79bc-76a3-8727-1508a5cff7e0",
        "storage_key": "property/6767906449167809/01a117c9-79bc-76a3-8727-1508a5cff7e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://foodland.ca/stores/foodland-woodstock/?utm_source=G&utm_medium=lpm&utm_campaign=Sobeys",
      "poi_directions_map_url": "https://maps.google.com/?cid=236353441921783090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foodland---woodstock",
      "poi_latitude": "43.132490999999995",
      "poi_longitude": "-80.749727",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 519-421-3420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287f-72fa-ab63-a3b8ce98c914.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287f-72fa-ab63-a3b8ce98c914",
        "storage_key": "property/6767906449167809/01a117c7-287f-72fa-ab63-a3b8ce98c914.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxy06eRQfLIgRMlUwAzSyRwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_0fb4e0ea-5eea-4b2f-ac3b-648799206241",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Scott's NOFRILLS Woodstock",
      "poi_type": "Shopping & Retail",
      "poi_address": "391 Norwich Ave, Woodstock, ON N4S 3W4, Canada",
      "poi_short_description": "Grocery store offering a wide range of household products and affordable prices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7967-7738-8c51-fe77cc351612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7967-7738-8c51-fe77cc351612",
        "storage_key": "property/6767906449167809/01a117c9-7967-7738-8c51-fe77cc351612.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nofrills.ca/store-locator/details/3463?utm_source=G&utm_medium=LPM&utm_campaign=Loblaws",
      "poi_directions_map_url": "https://maps.google.com/?cid=15547164835664864388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scotts-nofrills-woodstock",
      "poi_latitude": "43.119099",
      "poi_longitude": "-80.736389",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 866-987-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287f-72fa-ab63-a3b8ce98c914.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287f-72fa-ab63-a3b8ce98c914",
        "storage_key": "property/6767906449167809/01a117c7-287f-72fa-ab63-a3b8ce98c914.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQNXXkMfLIgRhKQ_rgugwtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_15b7110f-3f73-4791-bd0a-a4e17aaf8d93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Walmart Supercentre",
      "poi_type": "Shopping & Retail",
      "poi_address": "499 Norwich Ave, Woodstock, ON N4S 9A2, Canada",
      "poi_short_description": "Comprehensive department store offering a wide selection of everyday essentials, electronics, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7b50-7755-878b-fac8b556135f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7b50-7755-878b-fac8b556135f",
        "storage_key": "property/6767906449167809/01a117c9-7b50-7755-878b-fac8b556135f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.walmart.ca/en/store/3120?utm_source=local&utm_medium=listings&utm_campaign=sc&cmpid=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11938203827057850954&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercentre",
      "poi_latitude": "43.1153704",
      "poi_longitude": "-80.7333017",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-539-5120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-a8646b4e15b9",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-Z_i1sr20VMRSvr9HyEFraU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_5553ce9f-8537-4d0a-863f-61dd0647ad65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Shoppers Drug Mart",
      "poi_type": "Health and Wellness",
      "poi_address": "333 Dundas St, Woodstock, ON N4S 1B5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7a7b-7779-82cd-12b66d2b0840.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7a7b-7779-82cd-12b66d2b0840",
        "storage_key": "property/6767906449167809/01a117c9-7a7b-7779-82cd-12b66d2b0840.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.shoppersdrugmart.ca/en/stores/1171-shoppers-drug-mart-dundas-and-vansittart/?utm_source=G&utm_medium=lpm&utm_campaign=LPM_SDM",
      "poi_directions_map_url": "https://maps.google.com/?cid=6360698541244618180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoppers-drug-mart",
      "poi_latitude": "43.129793",
      "poi_longitude": "-80.762923",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-537-3491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a42e-70a5-81dc-10b4c6965550.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a42e-70a5-81dc-10b4c6965550",
        "storage_key": "property/6767906449167809/01a117c9-a42e-70a5-81dc-10b4c6965550.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJISPfzXQfLIgRxBU7cp-9RVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_d14a7f16-35b3-4b5f-b634-88692285e5d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Pharmasave Woodstock General",
      "poi_type": "Health and Wellness",
      "poi_address": "310 Juliana Dr Unit #1, Woodstock, ON N4V 0A4, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7b55-70ce-b556-252031ac45c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7b55-70ce-b556-252031ac45c2",
        "storage_key": "property/6767906449167809/01a117c9-7b55-70ce-b556-252031ac45c2.webp",
        "width": 640,
        "height": 361
      },
      "poi_business_url": "https://pharmasave.com/woodstock-general-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10448336919492835153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pharmasave-woodstock-general",
      "poi_latitude": "43.1066235",
      "poi_longitude": "-80.7537869",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-421-4272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a42e-70a5-81dc-10b4c6965550.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a42e-70a5-81dc-10b4c6965550",
        "storage_key": "property/6767906449167809/01a117c9-a42e-70a5-81dc-10b4c6965550.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj_qybkUhLIgRUTf4ExLz_5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_bda139b2-f956-4521-b036-b97405fb7b9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Rexall",
      "poi_type": "Health and Wellness",
      "poi_address": "706 Dundas St, Woodstock, ON N4S 1E7, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7c4f-7601-9131-6a19853afc6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7c4f-7601-9131-6a19853afc6a",
        "storage_key": "property/6767906449167809/01a117c9-7c4f-7601-9131-6a19853afc6a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.rexall.ca/storelocator/store/6912?utm_source=gbp&utm_medium=organic&utm_campaign=6912",
      "poi_directions_map_url": "https://maps.google.com/?cid=456206056917055455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rexall",
      "poi_latitude": "43.130856",
      "poi_longitude": "-80.746348",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-421-3784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK65KThQfLIgR3zfs3v3EVAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_c0e005b2-4219-4606-b072-68b4f083fa07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "361 Norwich Ave, Woodstock, ON N4S 3W1, Canada",
      "poi_short_description": "Convenience store offering quick essentials, fountain drinks, and slushies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7f93-735e-ae9f-2dc53d2a300c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7f93-735e-ae9f-2dc53d2a300c",
        "storage_key": "property/6767906449167809/01a117c9-7f93-735e-ae9f-2dc53d2a300c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.circlek.com/ca/ontario/store-locator/CA/woodstock/361-norwich-ave/0864036?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6773651748890644645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "43.1204949",
      "poi_longitude": "-80.7389859",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-539-5260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a450-707f-afc8-a903c9329cd5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a450-707f-afc8-a903c9329cd5",
        "storage_key": "property/6767906449167809/01a117c9-a450-707f-afc8-a903c9329cd5.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQS2ndEMfLIgRpZDUlGDYAF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_922d0c5d-ba97-4dd5-89ae-5e73b61d9de1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "419 Norwich Ave, Woodstock, ON N4S 3W4, Canada",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7dec-7449-8024-1555d4fc3ee4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7dec-7449-8024-1555d4fc3ee4",
        "storage_key": "property/6767906449167809/01a117c9-7dec-7449-8024-1555d4fc3ee4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.petsmart.ca/stores/ca/on/woodstock-store2767.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=1285989541099720854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "43.118271199999995",
      "poi_longitude": "-80.7371622",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-537-8395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-a8646b4e15b9",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUbGKrUQfLIgRltAdlqzA2BE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_66843d42-c7c7-4a18-aeea-1eff8e337745",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Canadian Tire",
      "poi_type": "Shopping & Retail",
      "poi_address": "465 Norwich Ave, Woodstock, ON N4S 9A2, Canada",
      "poi_short_description": "Spacious department store offering automotive services, hardware, and home supplies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-7e65-724a-a2dc-dbbdca7882e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-7e65-724a-a2dc-dbbdca7882e1",
        "storage_key": "property/6767906449167809/01a117c9-7e65-724a-a2dc-dbbdca7882e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.canadiantire.ca/en/store-details/on/woodstock-on-124.html?utm_source=google&utm_medium=lss&utm_content=124",
      "poi_directions_map_url": "https://maps.google.com/?cid=3559439081382868246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canadian-tire",
      "poi_latitude": "43.1162359",
      "poi_longitude": "-80.7366404",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-539-1201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-a8646b4e15b9",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnxe7oVsfLIgRFvV3XfyqZTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_aaf487d2-eae3-41a8-9b96-23f7e9a4a0a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "901 Juliana Dr, Woodstock, ON N4V 1B9, Canada",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c6-f791-77e8-ac41-ac5815aa710a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c6-f791-77e8-ac41-ac5815aa710a",
        "storage_key": "property/6767906449167809/01a117c6-f791-77e8-ac41-ac5815aa710a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.homedepot.ca/on/woodstock/home-improvement-woodstock-on-7182.html?utm_source=google&utm_medium=organic&utm_campaign=local&utm_content=7182",
      "poi_directions_map_url": "https://maps.google.com/?cid=13829855103155737619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "43.1171771",
      "poi_longitude": "-80.73106899999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-421-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-a8646b4e15b9",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxWgLtlEfLIgRE5S4TvGD7b8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_8e025544-6af1-45a0-85dd-7949a6478dd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Oliver Stephens Public School",
      "poi_type": "Education",
      "poi_address": "164 Fyfe Ave, Woodstock, ON N4S 3S6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-85ce-732e-9e54-973840bfb561.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-85ce-732e-9e54-973840bfb561",
        "storage_key": "property/6767906449167809/01a117c9-85ce-732e-9e54-973840bfb561.webp",
        "width": 1280,
        "height": 845
      },
      "poi_business_url": "https://www.tvdsb.ca/oliverstephens",
      "poi_directions_map_url": "https://maps.google.com/?cid=4766772720690554010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oliver-stephens-public-school",
      "poi_latitude": "43.121402499999995",
      "poi_longitude": "-80.7433473",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-539-2068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4bY2eUIfLIgRmmTItYj6JkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7076c336-c545-4258-b53f-c7227b8c6038",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Winchester Street Public School",
      "poi_type": "Major Employers & Offices",
      "poi_address": "110 Winchester St, Woodstock, ON N4S 7K5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-81fb-77fc-b1cd-3ae55a3c448b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-81fb-77fc-b1cd-3ae55a3c448b",
        "storage_key": "property/6767906449167809/01a117c9-81fb-77fc-b1cd-3ae55a3c448b.webp",
        "width": 1280,
        "height": 827
      },
      "poi_business_url": "https://www.tvdsb.ca/winchester",
      "poi_directions_map_url": "https://maps.google.com/?cid=5937468787086587802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winchester-street-public-school",
      "poi_latitude": "43.1369467",
      "poi_longitude": "-80.74081149999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 519-537-3543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSS0QJj0fLIgRmvdDX2cgZlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_195a2b27-116b-488a-99bb-25cf1832c7c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Central Public School",
      "poi_type": "Education",
      "poi_address": "410 Hunter St, Woodstock, ON N4S 4G4, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-82c5-739f-9516-badfa6a0107b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-82c5-739f-9516-badfa6a0107b",
        "storage_key": "property/6767906449167809/01a117c9-82c5-739f-9516-badfa6a0107b.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.tvdsb.ca/centralps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5331039959799076826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-public-school",
      "poi_latitude": "43.1306877",
      "poi_longitude": "-80.7592755",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-537-5362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlQk0mgwfLIgR2pc8L5mo-0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3fd75b05-c2d5-4fd6-a21e-ce580702ad09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Roch Carrier French Immersion",
      "poi_type": "Education",
      "poi_address": "840 Sloane St, Woodstock, ON N4S 7V3, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8698-7109-abdc-80730e5453c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8698-7109-abdc-80730e5453c4",
        "storage_key": "property/6767906449167809/01a117c9-8698-7109-abdc-80730e5453c4.webp",
        "width": 1280,
        "height": 842
      },
      "poi_business_url": "https://www.tvdsb.ca/rochcarrier",
      "poi_directions_map_url": "https://maps.google.com/?cid=9992403396562622035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roch-carrier-french-immersion",
      "poi_latitude": "43.1403615",
      "poi_longitude": "-80.7418292",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 519-537-7321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFWEVaCIfLIgRU5aFePIlrIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_56d7ba5f-060c-443a-9cc3-4bb3fe28b33f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Northdale Public School",
      "poi_type": "Education",
      "poi_address": "290 Victoria St N, Woodstock, ON N4S 6W5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-81fb-77fc-b1cd-3f95df4d38b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-81fb-77fc-b1cd-3f95df4d38b1",
        "storage_key": "property/6767906449167809/01a117c9-81fb-77fc-b1cd-3f95df4d38b1.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://northdalewoodstock.tvdsb.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8246516924640610145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northdale-public-school",
      "poi_latitude": "43.1405643",
      "poi_longitude": "-80.7554729",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 519-537-5761",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEY1PJQUfLIgRYUdzd3ODcXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_895eb143-d215-4098-86af-32e08faefd86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Eastdale Public School",
      "poi_type": "Education",
      "poi_address": "65 Aileen Dr, Woodstock, ON N4S 4A2, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8632-7254-9499-0273c3abf2ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8632-7254-9499-0273c3abf2ce",
        "storage_key": "property/6767906449167809/01a117c9-8632-7254-9499-0273c3abf2ce.webp",
        "width": 1280,
        "height": 842
      },
      "poi_business_url": "https://www.tvdsb.ca/eastdale",
      "poi_directions_map_url": "https://maps.google.com/?cid=12197634577390996143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastdale-public-school",
      "poi_latitude": "43.1251842",
      "poi_longitude": "-80.73388779999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-537-2652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3UMNt0cfLIgRr4pptQW0Rqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_551e40e9-fe6a-4c20-9cc4-b8ca7e8fd577",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "College Avenue Secondary School",
      "poi_type": "Education",
      "poi_address": "700 College Ave, Woodstock, ON N4S 2C8, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-832b-7609-9522-af4af7d14e10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-832b-7609-9522-af4af7d14e10",
        "storage_key": "property/6767906449167809/01a117c9-832b-7609-9522-af4af7d14e10.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://www.tvdsb.ca/collegeavenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=15272197939292851135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-avenue-secondary-school",
      "poi_latitude": "43.124178099999995",
      "poi_longitude": "-80.7452306",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-539-0020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg-7SFGofLIgRv8sANxy_8dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e778cb3b-f75c-4ebf-a339-8ccec896d2db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Huron Park Secondary School",
      "poi_type": "Education",
      "poi_address": "900 Cromwell St, Woodstock, ON N4S 5B5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8566-714e-bc9f-a3ea384838a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8566-714e-bc9f-a3ea384838a8",
        "storage_key": "property/6767906449167809/01a117c9-8566-714e-bc9f-a3ea384838a8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tvdsb.ca/huronpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=15651144613797211055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huron-park-secondary-school",
      "poi_latitude": "43.1396789",
      "poi_longitude": "-80.7395477",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 519-537-2347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfWnzdiMfLIgRr6umWRoJNNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_14e05406-382a-415f-a09e-0a833431de55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "St. Mary’s Catholic High School",
      "poi_type": "Education",
      "poi_address": "431 Juliana Dr, Woodstock, ON N4V 1E8, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://smh.ldcsb.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=997811992703931881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-marys-catholic-high-school",
      "poi_latitude": "43.1126821",
      "poi_longitude": "-80.7489602",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-675-4435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd9a4IWEfLIgR6RW-gbjw2A0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e4426876-82d4-4eb0-9e9d-858e4387b541",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Fanshawe College - Woodstock/Oxford Regional Campus",
      "poi_type": "Education",
      "poi_address": "369 Finkle St, Woodstock, ON N4V 1A3, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c6-f970-7070-9547-77bc238f7484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c6-f970-7070-9547-77bc238f7484",
        "storage_key": "property/6767906449167809/01a117c6-f970-7070-9547-77bc238f7484.webp",
        "width": 1280,
        "height": 481
      },
      "poi_business_url": "https://www.fanshawec.ca/why-fanshawe/campuses/woodstock-oxford",
      "poi_directions_map_url": "https://maps.google.com/?cid=9782621115171848706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fanshawe-college---woodstockoxford-regional-campus",
      "poi_latitude": "43.1150738",
      "poi_longitude": "-80.7512337",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-421-0144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-797551bc9b28",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-797551bc9b28.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ19LycGQfLIgRAsIN3hLawoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fc404557-639c-4a5e-9777-5ad3176eaec0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Gallery Cinemas",
      "poi_type": "Entertainment",
      "poi_address": "15 Perry St, Woodstock, ON N4S 3C1, Canada",
      "poi_short_description": "Roomy, independently owned movie theatre with concessions & multiple screens for first-run films.",
      "poi_long_description": "Roomy, independently owned movie theatre with concessions & multiple screens for first-run films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-88f2-70f8-b772-7e0b507bab53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-88f2-70f8-b772-7e0b507bab53",
        "storage_key": "property/6767906449167809/01a117c9-88f2-70f8-b772-7e0b507bab53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gallerycinemas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8547990830650694879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallery-cinemas",
      "poi_latitude": "43.1291838",
      "poi_longitude": "-80.7586378",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-421-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a437-744b-9799-9670b1e58c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a437-744b-9799-9670b1e58c7c",
        "storage_key": "property/6767906449167809/01a117c9-a437-744b-9799-9670b1e58c7c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RXYtAwfLIgR3xw7DF-QoHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_54f6cc1c-5fa7-4f98-a072-24caeb71d9d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "The Oxford Drive-In Theatre",
      "poi_type": "Entertainment",
      "poi_address": "684471 Rd 68, Woodstock, ON N0J 1A0, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-895a-70a5-8f97-81255eebaf2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-895a-70a5-8f97-81255eebaf2b",
        "storage_key": "property/6767906449167809/01a117c9-895a-70a5-8f97-81255eebaf2b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://m.facebook.com/OxfordDriveIn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10841001665320083004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-oxford-drive-in-theatre",
      "poi_latitude": "43.1129938",
      "poi_longitude": "-80.8209803",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 519-537-7392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a437-744b-9799-9670b1e58c7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a437-744b-9799-9670b1e58c7c",
        "storage_key": "property/6767906449167809/01a117c9-a437-744b-9799-9670b1e58c7c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7CqkvAfLIgRPF7SlpP5cpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_32d8fc8a-520d-425f-8b16-ba1ffac94e1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Woodstock Museum National Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "466 Dundas St, Woodstock, ON N4S 1C4, Canada",
      "poi_short_description": "Informative history museum showcasing local historical artifacts within a preserved heritage building.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c6-fd03-7354-84cd-085d8982e90c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c6-fd03-7354-84cd-085d8982e90c",
        "storage_key": "property/6767906449167809/01a117c6-fd03-7354-84cd-085d8982e90c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.woodstockmuseum.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5390230609074300435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodstock-museum-national-historic-site",
      "poi_latitude": "43.1292795",
      "poi_longitude": "-80.7574406",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-537-8411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28d4-745d-9dec-9cfc852afcd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28d4-745d-9dec-9cfc852afcd4",
        "storage_key": "property/6767906449167809/01a117c7-28d4-745d-9dec-9cfc852afcd4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0Gf1QwfLIgRE6ZPJy7yzUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_cd3b2114-8a1f-4824-b8b6-d20f6bbadc79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Woodstock Art Gallery",
      "poi_type": "Entertainment",
      "poi_address": "449 Dundas St, Woodstock, ON N4S 1C2, Canada",
      "poi_short_description": "Peaceful community art gallery featuring rotating exhibits and educational workshops.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8a2b-719e-b545-798991b4a458.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8a2b-719e-b545-798991b4a458",
        "storage_key": "property/6767906449167809/01a117c9-8a2b-719e-b545-798991b4a458.webp",
        "width": 650,
        "height": 488
      },
      "poi_business_url": "http://www.woodstockartgallery.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8978399396259816530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodstock-art-gallery",
      "poi_latitude": "43.130092399999995",
      "poi_longitude": "-80.7581968",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-539-6761",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a43d-760a-9d15-9b833d5bc6bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a43d-760a-9d15-9b833d5bc6bb",
        "storage_key": "property/6767906449167809/01a117c9-a43d-760a-9d15-9b833d5bc6bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4PMVwwfLIgRUuSlaa6umXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_8ce79ac4-3f43-4f09-99fe-a320356225a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Upper Thames Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "225 Bysham Park Dr #9, Woodstock, ON N4T 1P1, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8ffe-769a-942e-c1dfd1893969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8ffe-769a-942e-c1dfd1893969",
        "storage_key": "property/6767906449167809/01a117c9-8ffe-769a-942e-c1dfd1893969.webp",
        "width": 1280,
        "height": 364
      },
      "poi_business_url": "http://www.upperthamesbrewing.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14710915284250272236&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upper-thames-brewing-company",
      "poi_latitude": "43.1393942",
      "poi_longitude": "-80.72208979999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 519-290-0053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWJMySwfLIgR7CGaXoKrJ8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_9dce1586-77c3-4321-95b5-d7d1b26203e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Pittock Conservation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "221 Pittock Park Rd, Woodstock, ON N4T 0G2, Canada",
      "poi_short_description": "2,000 scenic acres on a reservoir, popular for camping, hiking, swimming, boating & disc golf.",
      "poi_long_description": "2,000 scenic acres on a reservoir, popular for camping, hiking, swimming, boating & disc golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-0dcf-7767-90aa-294cc9a1b1be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c7-0dcf-7767-90aa-294cc9a1b1be",
        "storage_key": "property/6767906449167809/01a117c7-0dcf-7767-90aa-294cc9a1b1be.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.pittockconservationarea.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12050985180182852317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pittock-conservation-area",
      "poi_latitude": "43.1563516",
      "poi_longitude": "-80.756085",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 519-539-5088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b00-72bc-986b-9dc1b95e4ae0",
        "storage_key": "property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl8zQifAeLIgR3bJLKiyzPac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5df43b21-8af8-44a3-b457-74221e672527",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Southside Aquatic Centre",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "315 Finkle St, Woodstock, ON N4S 3E3, Canada",
      "poi_short_description": "Family-friendly aquatic center featuring swimming lessons and a splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8d51-763a-ae1b-bf623e061481.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8d51-763a-ae1b-bf623e061481",
        "storage_key": "property/6767906449167809/01a117c9-8d51-763a-ae1b-bf623e061481.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityofwoodstock.ca/en/city-hall/southside-aquatic-centre.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=6558654856589335506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southside-aquatic-centre",
      "poi_latitude": "43.119238",
      "poi_longitude": "-80.7534908",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 519-539-2382 ext. 2701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Zkj6GQfLIgR0ttlw9cFBVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_f6ad6e49-58e1-4805-a48d-793941c367c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Theatre Woodstock",
      "poi_type": "Entertainment",
      "poi_address": "22 Reeve St, Woodstock, ON N4S 8X8, Canada",
      "poi_short_description": "Community performing arts theater hosting live theatrical productions and youth performance training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8c89-76fc-ac4a-5d5047c3febd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8c89-76fc-ac4a-5d5047c3febd",
        "storage_key": "property/6767906449167809/01a117c9-8c89-76fc-ac4a-5d5047c3febd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.theatrewoodstock.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12691352432078502553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "theatre-woodstock",
      "poi_latitude": "43.1293611",
      "poi_longitude": "-80.7562967",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-537-2582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a43d-760a-9d15-9b833d5bc6bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a43d-760a-9d15-9b833d5bc6bb",
        "storage_key": "property/6767906449167809/01a117c9-a43d-760a-9d15-9b833d5bc6bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYQAkSg0fLIgRmTpUmcu9ILA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_b2dae639-7d52-43d8-a69b-b187060b6d62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Woodstock Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "310 Juliana Dr, Woodstock, ON N4V 0A6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-10fc-70c2-aff9-339eae5bc390.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c7-10fc-70c2-aff9-339eae5bc390",
        "storage_key": "property/6767906449167809/01a117c7-10fc-70c2-aff9-339eae5bc390.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.woodstockhospital.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11182587711398486779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodstock-hospital",
      "poi_latitude": "43.106256599999995",
      "poi_longitude": "-80.75282969999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-421-4211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-7d7e181e0c11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-7d7e181e0c11",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-7d7e181e0c11.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQUbMNghLIgR-yKOj0aIMJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e24ff686-a387-483e-a0df-e63ee35afbb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Fit4Less",
      "poi_type": "Health and Wellness",
      "poi_address": "580 Bruin Blvd, Woodstock, ON N4V 1E5, Canada",
      "poi_short_description": "Affordable, welcoming gym featuring essential workout equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c6-ffb6-70ab-a835-5a5c6ee4aa63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c6-ffb6-70ab-a835-5a5c6ee4aa63",
        "storage_key": "property/6767906449167809/01a117c6-ffb6-70ab-a835-5a5c6ee4aa63.webp",
        "width": 1271,
        "height": 1280
      },
      "poi_business_url": "https://www.fit4less.ca/locations/provinces/ontario/woodstock/woodstock-bruin-blvd?utm_source=G&utm_medium=lpm&utm_campaign=fit4less",
      "poi_directions_map_url": "https://maps.google.com/?cid=7698727015883001114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit4less",
      "poi_latitude": "43.111711",
      "poi_longitude": "-80.73812199999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-421-5201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbq5zF4fLIgRGs1obG5f12o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d5463d1b-cd3c-4f19-b5c6-dc0ab062839a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "GoodLife Fitness Woodstock Dundas and Kent",
      "poi_type": "Health and Wellness",
      "poi_address": "645 Dundas St, Woodstock, ON N4S 1E4, Canada",
      "poi_short_description": "Modern gym offering diverse fitness classes and well-maintained exercise equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c6-ffb2-7468-8b74-c97aac9dc34b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c6-ffb2-7468-8b74-c97aac9dc34b",
        "storage_key": "property/6767906449167809/01a117c6-ffb2-7468-8b74-c97aac9dc34b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.goodlifefitness.com/clubs/club.42.html?utm_source=G&utm_medium=LPM&utm_campaign=GoodlifeFitness",
      "poi_directions_map_url": "https://maps.google.com/?cid=13026528349267295857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodlife-fitness-woodstock-dundas-and-kent",
      "poi_latitude": "43.132971999999995",
      "poi_longitude": "-80.749765",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-539-3396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbcG9xMfLIgRcf6hIoSGx7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5ac8a382-7aa6-4ada-8afb-47d589b5a773",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Northwood Medical Centre Walk-In Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "35 Springbank Ave, Woodstock, ON N4S 7P6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8e6b-7165-aa0f-0daf296f6d15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8e6b-7165-aa0f-0daf296f6d15",
        "storage_key": "property/6767906449167809/01a117c9-8e6b-7165-aa0f-0daf296f6d15.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7863182769381024662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwood-medical-centre-walk-in-clinic",
      "poi_latitude": "43.1349144",
      "poi_longitude": "-80.7296472",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-537-6147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD0VPpDEfLIgRlqPtXBGjH20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_09ef944b-930e-4b39-b2eb-58b06546bd31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Perry Street Medical Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "12 Perry St, Woodstock, ON N4S 3C2, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16717725358267687703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perry-street-medical-clinic",
      "poi_latitude": "43.1291604",
      "poi_longitude": "-80.7594249",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw4txTgAfLIgRF-MVmKNKAeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_a4e90d09-e300-4409-b4dd-954bf2de6236",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Woodstonian Health",
      "poi_type": "Health and Wellness",
      "poi_address": "300 Main St Unit 2, Woodstock, ON N4S 1T3, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8e7d-752d-9322-062bce5641b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8e7d-752d-9322-062bce5641b1",
        "storage_key": "property/6767906449167809/01a117c9-8e7d-752d-9322-062bce5641b1.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://woodstonianhealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1072628717418186365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodstonian-health",
      "poi_latitude": "43.1258549",
      "poi_longitude": "-80.763919",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 519-533-5414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEw9nARofLIgRfQaYrSK-4g4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "physiotherapist"
    },
    {
      "id": "custom_7c0ff03c-8268-4e98-8494-a71d2e1a9c63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Woodstock Massage Therapy @ The Calm Therapeutic Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "842 Nellis St, Woodstock, ON N4S 4C3, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-8f2e-7654-a0a3-81156d6d1bb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-8f2e-7654-a0a3-81156d6d1bb2",
        "storage_key": "property/6767906449167809/01a117c9-8f2e-7654-a0a3-81156d6d1bb2.webp",
        "width": 555,
        "height": 312
      },
      "poi_business_url": "https://thecalmtc.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14106726907934699654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodstock-massage-therapy--the-calm-therapeutic-centre",
      "poi_latitude": "43.1329845",
      "poi_longitude": "-80.740713",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 519-602-5562",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2TgjGz4fLIgRhnDk0mEpxcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage"
    },
    {
      "id": "custom_8236da61-29d9-43aa-a8e6-04c47a4d00ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Southside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "192 Old Wellington St S, Woodstock, ON N4S 3L3, Canada",
      "poi_short_description": "Local hub for sports & seasonal events, with a river, playground, skate park & picnic facilities.",
      "poi_long_description": "Local hub for sports & seasonal events, with a river, playground, skate park & picnic facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-12e5-7179-893f-983ef95d32fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c7-12e5-7179-893f-983ef95d32fe",
        "storage_key": "property/6767906449167809/01a117c7-12e5-7179-893f-983ef95d32fe.webp",
        "width": 1280,
        "height": 985
      },
      "poi_business_url": "https://www.cityofwoodstock.ca/modules/facilities/Detail.aspx?CategoryIds=&FacilityTypeIds=&Keywords=southside&ScrollMap=true&CloseMap=false&id=f4bc0847-40cb-4e6c-8bc0-6d91a4393f5d",
      "poi_directions_map_url": "https://maps.google.com/?cid=887942270682539910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southside-park",
      "poi_latitude": "43.1232147",
      "poi_longitude": "-80.7528938",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-539-2382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b00-72bc-986b-9dc1b95e4ae0",
        "storage_key": "property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3lrB28fLIgRhicWacqaUgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_42b8c4ae-d5d5-442c-ac49-67078896439f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Roth Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Huron St North, 680 Highland Dr, Woodstock, ON N4S 5X2, Canada",
      "poi_short_description": "Scenic park featuring diverse walking and biking trails and a dedicated dog park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-11b4-72de-a7d5-87cb8ccf82f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c7-11b4-72de-a7d5-87cb8ccf82f5",
        "storage_key": "property/6767906449167809/01a117c7-11b4-72de-a7d5-87cb8ccf82f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://thamesriver.on.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1492641930552004840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roth-park",
      "poi_latitude": "43.1500771",
      "poi_longitude": "-80.7525845",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b00-72bc-986b-9dc1b95e4ae0",
        "storage_key": "property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-lm9-IeLIgR6NBnb-3tthQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2bc43fb8-ac5b-450a-8b58-642ecc13820f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Cowan Sportsplex",
      "poi_type": "Entertainment",
      "poi_address": "895 Ridgewood Drive, Woodstock, ON N4T 0A6, Canada",
      "poi_short_description": "Multi-sport event venue featuring soccer fields and party rental facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-93ec-7444-bedb-8a447787aefb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-93ec-7444-bedb-8a447787aefb",
        "storage_key": "property/6767906449167809/01a117c9-93ec-7444-bedb-8a447787aefb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityofwoodstock.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9580399470312277477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cowan-sportsplex",
      "poi_latitude": "43.155843",
      "poi_longitude": "-80.7704222",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 519-539-1291 ext. 2740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-28ca-759c-bdf4-84d0bd50a871.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-28ca-759c-bdf4-84d0bd50a871",
        "storage_key": "property/6767906449167809/01a117c7-28ca-759c-bdf4-84d0bd50a871.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJL69fuFMeLIgR5cVNIo9q9IQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_b80b7477-6986-4c5b-bc35-b9c7cf74b658",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Standard Tube Burgess Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Tecumseh St, Woodstock, ON N4S 6B2, Canada",
      "poi_short_description": "Scenic park featuring well-maintained walking trails and diverse wildlife.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9229-71c4-ae49-75158662ef89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9229-71c4-ae49-75158662ef89",
        "storage_key": "property/6767906449167809/01a117c9-9229-71c4-ae49-75158662ef89.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2110266593268297474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "standard-tube-burgess-park",
      "poi_latitude": "43.145177200000006",
      "poi_longitude": "-80.7679589",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b00-72bc-986b-9dc1b95e4ae0",
        "storage_key": "property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJp6cjMKofLIgRAm8hMUksSR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_71ebc1f0-2121-4408-80b2-8756123f4940",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Standard Tube Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "98 Dundas St, Woodstock, ON N4S 7V7, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9185-77d1-9c54-c067b4d38c4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9185-77d1-9c54-c067b4d38c4f",
        "storage_key": "property/6767906449167809/01a117c9-9185-77d1-9c54-c067b4d38c4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofwoodstock.ca/en/live-and-play/parks-and-trails.aspx#",
      "poi_directions_map_url": "https://maps.google.com/?cid=7124767827926099287&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "standard-tube-park",
      "poi_latitude": "43.127001",
      "poi_longitude": "-80.77852399999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-539-2382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a455-71db-996e-5a2b3c7ec830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a455-71db-996e-5a2b3c7ec830",
        "storage_key": "property/6767906449167809/01a117c9-a455-71db-996e-5a2b3c7ec830.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJie5-VBofLIgRV6WqQpdC4GI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_e359df7b-a719-4fbc-a14f-a7cdb3a4c4f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Cedar Creek Park/Youth Start Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "122 Dundas St, Woodstock, ON N4S 1A2, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9220-77ef-bed8-41aa0117b6b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9220-77ef-bed8-41aa0117b6b9",
        "storage_key": "property/6767906449167809/01a117c9-9220-77ef-bed8-41aa0117b6b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=595994672312006171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-creek-parkyouth-start-trail",
      "poi_latitude": "43.1271569",
      "poi_longitude": "-80.77479919999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b00-72bc-986b-9dc1b95e4ae0",
        "storage_key": "property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0ygjvJkfLIgRG7YuK_9lRQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_345fa2d8-5101-4009-bbc9-16fbb681621f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Victoria Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "413 Buller St, Woodstock, ON N4S 4N2, Canada",
      "poi_short_description": "Peaceful community park featuring a historic war memorial and sports facilities under mature trees.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-93eb-7667-968e-0482f309ba85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-93eb-7667-968e-0482f309ba85",
        "storage_key": "property/6767906449167809/01a117c9-93eb-7667-968e-0482f309ba85.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.cityofwoodstock.ca/en/live-and-play/art-in-victoria-park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13051821969942955150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "victoria-park",
      "poi_latitude": "43.133957599999995",
      "poi_longitude": "-80.76055149999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-539-2382 ext. 4101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b00-72bc-986b-9dc1b95e4ae0",
        "storage_key": "property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP5tvEgwfLIgRjsQWHu5iIbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fdcc70fb-3c56-41a6-b823-d18f63e6734e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Argyle Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "391 Hay St, Woodstock, ON N4S 2C5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9450-7614-be20-09e125dec0f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9450-7614-be20-09e125dec0f1",
        "storage_key": "property/6767906449167809/01a117c9-9450-7614-be20-09e125dec0f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3737007661899456439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "argyle-park",
      "poi_latitude": "43.1228085",
      "poi_longitude": "-80.7575846",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b00-72bc-986b-9dc1b95e4ae0",
        "storage_key": "property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-5MonEfLIgRtx9uQquE3DM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_39890fe5-8dcb-4861-ab9c-7f65305fd1da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Brompton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "871 Grosvenor St, Woodstock, ON N4S 5H1, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cityofwoodstock.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7517546882483292882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brompton-park",
      "poi_latitude": "43.143356399999995",
      "poi_longitude": "-80.74128329999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 519-539-1291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b00-72bc-986b-9dc1b95e4ae0",
        "storage_key": "property/6767906449167809/01a117c7-2b00-72bc-986b-9dc1b95e4ae0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhxnAsTUfLIgR0grDWA-xU2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_10fddf5a-6f84-4503-bb42-f1102752e357",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Woodstock",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 Victoria St S, Woodstock, ON N4S 8R4, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-16c1-7576-9b5a-745ac7186e06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c7-16c1-7576-9b5a-745ac7186e06",
        "storage_key": "property/6767906449167809/01a117c7-16c1-7576-9b5a-745ac7186e06.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13340745943534390144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodstock",
      "poi_latitude": "43.126388899999995",
      "poi_longitude": "-80.75213",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b35-7683-8889-deab322da119.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b35-7683-8889-deab322da119",
        "storage_key": "property/6767906449167809/01a117c7-2b35-7683-8889-deab322da119.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUbdBG0fLIgRgMsZ28DZI7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_9a776380-88a3-443b-a5a1-eaaa899ec8b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Transit Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "623 Dundas St, Woodstock, ON N4S 1E1, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9765-750a-9d9c-4acb1dee32a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9765-750a-9d9c-4acb1dee32a2",
        "storage_key": "property/6767906449167809/01a117c9-9765-750a-9d9c-4acb1dee32a2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofwoodstock.ca/en/living-in-woodstock/transit.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=2785257238930758467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "transit-terminal",
      "poi_latitude": "43.13131200000001",
      "poi_longitude": "-80.75017199999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-539-2382 ext. 3130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a446-713d-8bb5-70dff080f1ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a446-713d-8bb5-70dff080f1ca",
        "storage_key": "property/6767906449167809/01a117c9-a446-713d-8bb5-70dff080f1ca.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTxwynBMfLIgRQ5uNrrM4pyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_d31ad003-d13c-4818-933e-f9b5c091b213",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "SmartCentres Woodstock",
      "poi_type": "Shopping & Retail",
      "poi_address": "499 Norwich Ave, Woodstock, ON N4S 9A2, Canada",
      "poi_short_description": "Convenient shopping complex featuring a wide selection of big-box stores and ample parking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-95e6-76e8-b427-76670eb45591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-95e6-76e8-b427-76670eb45591",
        "storage_key": "property/6767906449167809/01a117c9-95e6-76e8-b427-76670eb45591.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://smartcentres.com/property/1358/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7000948170436636894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smartcentres-woodstock",
      "poi_latitude": "43.115867",
      "poi_longitude": "-80.733892",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 905-760-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-a8646b4e15b9",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-a8646b4e15b9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhfZJjVofLIgR3vDLtURdKGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c6b0ab7f-d26e-45aa-b8ca-0eda1351d2a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Woodstock Transit Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "Woodstock, ON N4S 1E4, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7243911449507255618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodstock-transit-terminal",
      "poi_latitude": "43.131194",
      "poi_longitude": "-80.74974999999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a44d-73ad-b915-94ba0a9308c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a44d-73ad-b915-94ba0a9308c4",
        "storage_key": "property/6767906449167809/01a117c9-a44d-73ad-b915-94ba0a9308c4.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJU0bhgxMfLIgRQtVDXBWLh2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_14e96e3e-7306-417c-80b3-c07bcaf1d58a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "ONroute Woodstock",
      "poi_type": "Transportation & Transit",
      "poi_address": "401225 ON-401, Woodstock, ON N4S 7W8, Canada",
      "poi_short_description": "Highway rest stop offering various fast food options and essential travel amenities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9643-7062-adfd-cb65dfbb1567.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9643-7062-adfd-cb65dfbb1567",
        "storage_key": "property/6767906449167809/01a117c9-9643-7062-adfd-cb65dfbb1567.webp",
        "width": 603,
        "height": 317
      },
      "poi_business_url": "https://www.onroute.ca/locations/woodstock",
      "poi_directions_map_url": "https://maps.google.com/?cid=17275336518148252601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onroute-woodstock",
      "poi_latitude": "43.0665269",
      "poi_longitude": "-80.7974947",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 519-423-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a444-7258-83db-7f30a5a958d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a444-7258-83db-7f30a5a958d8",
        "storage_key": "property/6767906449167809/01a117c9-a444-7258-83db-7f30a5a958d8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1k0uY8gLIgRuWOP2whTvu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "rest_stop"
    },
    {
      "id": "custom_9ac81e58-3910-4b85-bc5b-e0a5f39ed3b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "London International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "10 Seabrook Way, London, ON N5V 3B6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9960-76bd-ac6c-df97dfb52dcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9960-76bd-ac6c-df97dfb52dcd",
        "storage_key": "property/6767906449167809/01a117c9-9960-76bd-ac6c-df97dfb52dcd.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://flyyxu.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7721343355326277519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "london-international-airport",
      "poi_latitude": "43.0286636",
      "poi_longitude": "-81.1492462",
      "poi_miles_from_property": "38.4",
      "poi_walking_minutes": "8 hours 37 mins",
      "poi_biking_minutes": "2 hours 17 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 519-452-4015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b52-73ed-a228-01fcff8d4ff0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b52-73ed-a228-01fcff8d4ff0",
        "storage_key": "property/6767906449167809/01a117c7-2b52-73ed-a228-01fcff8d4ff0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJOfcJ5iWTLogRj6cLS9-4J2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2aaa7a23-f8fa-47c3-8a30-ca70da0973a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Toyota Motor Manufacturing Canada (West Plant)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1717 Dundas St, Woodstock, ON N4S 7V9, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9967-7718-b368-6aa5bfc5881b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9967-7718-b368-6aa5bfc5881b",
        "storage_key": "property/6767906449167809/01a117c9-9967-7718-b368-6aa5bfc5881b.webp",
        "width": 1280,
        "height": 660
      },
      "poi_business_url": "http://www.tmmc.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15787509351069657334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toyota-motor-manufacturing-canada-west-plant",
      "poi_latitude": "43.141750599999995",
      "poi_longitude": "-80.68985169999999",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 519-653-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WqnvTsyWkAR9iiq5huAGNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_d0ab766f-6b9b-48e8-a40f-12e263a86e3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "County of Oxford Community Planning Dept",
      "poi_type": "Major Employers & Offices",
      "poi_address": "21 Reeve St, Woodstock, ON N4S, Canada, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.oxfordcounty.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1464535404444157463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "county-of-oxford-community-planning-dept",
      "poi_latitude": "43.1296045",
      "poi_longitude": "-80.7559179",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-539-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b56-70ba-8b96-380538d6272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b56-70ba-8b96-380538d6272a",
        "storage_key": "property/6767906449167809/01a117c7-2b56-70ba-8b96-380538d6272a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQyyzZAsfLIgRF4bg3jATUxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_97df5ca4-4504-4d3b-8fdb-37969575af64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "City of Woodstock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Dundas St, Woodstock, ON N4S 0A7, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-1883-738e-8d8a-8a0150dc6d12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c7-1883-738e-8d8a-8a0150dc6d12",
        "storage_key": "property/6767906449167809/01a117c7-1883-738e-8d8a-8a0150dc6d12.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.cityofwoodstock.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14200906438199262002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-woodstock",
      "poi_latitude": "43.1299417",
      "poi_longitude": "-80.7563867",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-539-1291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b56-70ba-8b96-380538d6272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b56-70ba-8b96-380538d6272a",
        "storage_key": "property/6767906449167809/01a117c7-2b56-70ba-8b96-380538d6272a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWbUnPw0fLIgRMrtseSrBE8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_e8d08c29-e339-4d9e-9231-8453df7c13b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Ontario Court of Justice",
      "poi_type": "Major Employers & Offices",
      "poi_address": "415 Hunter St, Woodstock, ON N4S 4G6, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9d4c-703a-b04b-980a87932fdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9d4c-703a-b04b-980a87932fdf",
        "storage_key": "property/6767906449167809/01a117c9-9d4c-703a-b04b-980a87932fdf.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "http://www.ontariocourts.ca/ocj/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10897559246910187296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ontario-court-of-justice",
      "poi_latitude": "43.1317485",
      "poi_longitude": "-80.76004309999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 519-539-6187",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b56-70ba-8b96-380538d6272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b56-70ba-8b96-380538d6272a",
        "storage_key": "property/6767906449167809/01a117c7-2b56-70ba-8b96-380538d6272a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SyzZAsfLIgRIOfatmXoO5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_318b36b2-6ea4-4297-9669-8d30034afa98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Woodstock Police",
      "poi_type": "Major Employers & Offices",
      "poi_address": "615 Dundas St, Woodstock, ON N4S 1E1, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9a1b-7704-8c4c-5a6c8e0472f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9a1b-7704-8c4c-5a6c8e0472f7",
        "storage_key": "property/6767906449167809/01a117c9-9a1b-7704-8c4c-5a6c8e0472f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.woodstockpolice.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4894306040731657457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodstock-police",
      "poi_latitude": "43.1311044",
      "poi_longitude": "-80.7510478",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 519-537-2323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-a45d-708e-bdb8-1d7e238faef7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c9-a45d-708e-bdb8-1d7e238faef7",
        "storage_key": "property/6767906449167809/01a117c9-a45d-708e-bdb8-1d7e238faef7.webp",
        "width": 177,
        "height": 192
      },
      "poi_google_place_id": "ChIJSy2yFBMfLIgR8eTbs2kR7EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_88f14e11-9934-4f12-aaba-8a2c16d9f2b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Woodingford Lodge",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Juliana Dr, Woodstock, ON N4V 0A1, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9cde-7254-8540-23e68ca4462e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9cde-7254-8540-23e68ca4462e",
        "storage_key": "property/6767906449167809/01a117c9-9cde-7254-8540-23e68ca4462e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226833794901052652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodingford-lodge",
      "poi_latitude": "43.1073301",
      "poi_longitude": "-80.7555639",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-421-5556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP7uaWQAhLIgR7IwpPcS48vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_c994201c-539b-4a3f-bc6b-670ed27652ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Oxford County Paramedic Services HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "377 Mill St, Woodstock, ON N4V 1H5, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9cec-73fb-98a0-a7546bfa3659.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9cec-73fb-98a0-a7546bfa3659",
        "storage_key": "property/6767906449167809/01a117c9-9cec-73fb-98a0-a7546bfa3659.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.oxfordcounty.ca/en/services-for-you/about-paramedic-services.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9625954765978864592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxford-county-paramedic-services-hq",
      "poi_latitude": "43.1145977",
      "poi_longitude": "-80.7608455",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 519-539-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-287d-77cf-a4b9-ae0c027a67f6",
        "storage_key": "property/6767906449167809/01a117c7-287d-77cf-a4b9-ae0c027a67f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7RfpPF8fLIgR0Asm8ttCloU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_ab95afa7-ed16-4691-bc26-c6a40bf32ff2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "poi_name": "Southwestern Public Health",
      "poi_type": "Health and Wellness",
      "poi_address": "410 Buller St, Woodstock, ON N4S 6G9, Canada",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c9-9da3-7178-9180-18ad155c2427.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117c9-9da3-7178-9180-18ad155c2427",
        "storage_key": "property/6767906449167809/01a117c9-9da3-7178-9180-18ad155c2427.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.swpublichealth.ca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13828256170467982931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwestern-public-health",
      "poi_latitude": "43.1327247",
      "poi_longitude": "-80.7601699",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-922-0096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-2b56-70ba-8b96-380538d6272a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117c7-2b56-70ba-8b96-380538d6272a",
        "storage_key": "property/6767906449167809/01a117c7-2b56-70ba-8b96-380538d6272a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3ZGVLIfLIgRU_7Yx7jV578",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    }
  ],
  "office_hours": [
    {
      "id": "ec_07170949c20774ae01cfac54",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_7ef743b9c7441ddd9542cd12",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_0fa527c72a178ed7ae1444ae",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_82808d7ee1dcfb6bffe4c8e5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_b2e36ea567c28df0185dc581",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_276db2c107ffad5574e85224",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "rating": "5",
      "name": "Mackenzie",
      "text": "Beautiful place to live! Mostly everyone around the building is friendly and helpful, the lot and lawn are well maintained throughout the seasons. Management & maintenance are quick and efficient with any issues. Been here a few months now with no problems. Love that it's pet friendly too!! The gym is always clean and well equipped.\nWould recommend to anyone looking for a nice, clean environment and good managers :)",
      "date": "2026-04-28",
      "title": "false"
    },
    {
      "id": "ec_8f9331d51c90a620164b5045",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "rating": "5",
      "name": "Bonnie Davies",
      "text": "Beautiful building! Situated in the perfect area, quiet residential but super close to restaurants, shopping and the 401. The Butler II apartment is amazing - so modern and the modular design makes the most of every inch. The glass doors on the bedrooms give the space a bright and airy feel. All the amenities you could need are here, inside and out of the unit: stainless steel appliances, dishwasher, in-unit washer and dryer, plus an impressive community rooftop patio with BBQ, well-appointed workout room, and lounge with table tennis and foosball. Andrea, the property manager, made every step of the way an excellent experience - from the first visit to ensuring my move went well. Highly recommend!",
      "date": "2025-08-06",
      "title": "false"
    },
    {
      "id": "ec_6c37623f0c1caabe2c3efa20",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "rating": "5",
      "name": "Carla Riley",
      "text": "I moved in almost one week ago and Andrea made the move so easy. All the necessary paperwork was completed prior, got lots of information via email up to move in day and even managed to view an apartment the same day as I phoned. I tried several different buildings but Andrea was quick responding and is very accommodating which made the decision easier. In the time I've been there I've met some residents and everyone is welcoming. The building is very well maintained and clean with lots of common areas which I look forward to using!",
      "date": "2025-07-31",
      "title": "false"
    },
    {
      "id": "ec_c597c6d50368bd6011ad8c87",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "rating": "5",
      "name": "Berlin Tamarindo",
      "text": "I would like to firstly review the management at the FUZE Woodstock location. Andrea is the best landlord my wife and I have had in our lives.\n\nWe have rented, owned homes, travelled across the country and lived with some of our best friends, but since moving in here over a month ago we have never felt more at home.\n\nThe viewing experience beforehand was amazing, the application process was extremely professional, and when it came time to move in, management and staff were quick to make things as transitionally perfect as possible.\n\nMonthly gatherings and the cleanliness of the building is by far something you would expect from a first class hotel. Common areas are maintained impeccably and are always welcoming with all the amenities you would not expect from a rental apartment. These truly make it a condo experience.\n\nWe are glad to say we have met many great neighbors who are welcoming and look forward to welcoming new members to the building. I sure hope the community that management is trying to build continues to embrace the good people we already have here, and look forward to more tenants that value a quality place to call home.",
      "date": "2025-08-02",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_68d10c18-102d-4951-9b6b-5a70d03980e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Property Video",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/nSGH8lGGtML?source=180"
    },
    {
      "id": "custom_48fea4d4-7bec-4f03-8649-04bef411c079",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117c7-230e-7569-a937-d22c9975c601.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a117c7-230e-7569-a937-d22c9975c601",
        "storage_key": "property/6767906449167809/01a117c7-230e-7569-a937-d22c9975c601.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "FUZE Woodstock",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=679d6a005f124075cfbca195"
    },
    {
      "id": "custom_776d2ab5-5c20-4dfc-aa24-eb9bb91bfda2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117ca-abc6-72be-b60a-39ecdbfd1019.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a117ca-abc6-72be-b60a-39ecdbfd1019",
        "storage_key": "property/6767906449167809/01a117ca-abc6-72be-b60a-39ecdbfd1019.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 827 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tdrVhRoDjVJ"
    },
    {
      "id": "custom_3d161e4a-e08d-4299-b6d9-48388154e1fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117ca-bfe6-706c-93d4-03f76bed0a31.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a117ca-bfe6-706c-93d4-03f76bed0a31",
        "storage_key": "property/6767906449167809/01a117ca-bfe6-706c-93d4-03f76bed0a31.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 487 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UiUFiBRXAUJ"
    },
    {
      "id": "custom_f6542097-5542-4c8c-8339-5cd02274db39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117ca-c92f-738b-9f4e-a892036cc096.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a117ca-c92f-738b-9f4e-a892036cc096",
        "storage_key": "property/6767906449167809/01a117ca-c92f-738b-9f4e-a892036cc096.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Dining Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JnX3n3nsVaq"
    },
    {
      "id": "custom_998447a1-3980-4e44-9742-b385129fa302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117ca-c5c6-751f-91ad-b3be6d367142.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a117ca-c5c6-751f-91ad-b3be6d367142",
        "storage_key": "property/6767906449167809/01a117ca-c5c6-751f-91ad-b3be6d367142.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YGv1VMNBFwR"
    },
    {
      "id": "custom_2f5f7d5b-aaf1-4eb7-98fd-45268f4a9e72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167809/01a117ca-bcce-7718-afb2-3c4c948dd4e5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a117ca-bcce-7718-afb2-3c4c948dd4e5",
        "storage_key": "property/6767906449167809/01a117ca-bcce-7718-afb2-3c4c948dd4e5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Centre",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=k2R95kULDwu"
    }
  ],
  "faqs": [
    {
      "id": "custom_a6ca68e0-d52d-44bb-ac20-f17f646e29aa",
      "question": "What makes your community unique?",
      "answer": "We're setting the standard for contemporary design and exceptional amenities in Woodstock. Nestled just steps away from Southside Park and a mere 3-minute drive from the 401, our location is simply unparalleled. We are proud to be Canadian built and Canadian owned!",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_25f85a3f-7fde-49fa-8417-a6f55f5fc29e",
      "question": "What amenities do you offer?",
      "answer": "Enjoy exclusive access to a 24-hour fitness center, resident lounge with ping-pong and foosball, bike storage, pet wash station, energy-efficient insulation for lower utility costs, reserved parking, and a rooftop lounge with a kitchen and terrace. We’re also proudly pet-friendly.",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_920d343a-5614-421b-8302-0139883aa7cb",
      "question": "Where are you located?",
      "answer": "Our address is 140 Ferguson Drive, Woodstock, ON N4V 0E3.",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_1c892d18-62f3-4ed3-b42d-afafd5363152",
      "question": "What types of floorplans do you offer?",
      "answer": "We offer Studios, 1-Bedroom, and 2-Bedroom Floorplans.",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_045014b5-4624-48bd-8d61-8e155fffdcc4",
      "question": "What are your office hours?",
      "answer": "Monday: 10:00 AM - 5:00 PM Tuesday: 10:00 AM - 5:00 PM Wednesday: 10:00 AM - 6:00 PM Thursday: 10:00 AM - 5:00 PM Friday: 10:00 AM - 5:00 PM Saturday: Closed Sunday: Closed",
      "category": "General Community Information",
      "source": "custom"
    },
    {
      "id": "custom_bbd35b37-f289-4507-82d8-17a06dc8b525",
      "question": "How do I apply?",
      "answer": "Applying is easy via our website here at www.fuzewoodstock.com! Start by selecting your desired floorplan and clicking the Lease Now button. You may also contact our office for a direct link to an application sent via email.",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_2e05a60e-0eb3-48bf-9404-3f91729b6ee7",
      "question": "Is there an application fee?",
      "answer": "No application fees required to begin the process of securing your next home!",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_13361348-fce1-4d6c-bb90-f31407a8a763",
      "question": "What information is required for an application?",
      "answer": "We request basic indentification information: a copy of Government Issued ID (Driver's license or Passport), three most recent pay-stubs from your place of employment, and current home address. For retirees, we may request other documents for proof-of-income via savings.",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_4dfb5d27-0264-443d-b364-08997749855c",
      "question": "What are the income requirements?",
      "answer": "Screening criteria include a rent to income ratio not exceeding 40%. A guarantor may be required to strengthen an application (also known as a co-signer).",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_737b8ac0-c61e-4abc-a3de-c4118ca17562",
      "question": "Do you run credit checks?",
      "answer": "Yes, all applications will go through a credit screening process.",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_746f10f8-6906-4af2-8228-405b13671b49",
      "question": "Is renter's insurance required?",
      "answer": "Proof of renter's insurance is required before handover of keys.",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_30c37b5e-c414-44d3-bcf4-02dfc1fe4487",
      "question": "What lease terms are available?",
      "answer": "12 month fixed lease term agreements for new move-ins.",
      "category": "Leasing & Application Process",
      "source": "custom"
    },
    {
      "id": "custom_98c0fc12-f33f-4ac0-922a-c07c2e6d09cb",
      "question": "Is the community pet friendly?",
      "answer": "Yes! We are paw-friendly. As permitted by Ontario Law.",
      "category": "Policies",
      "source": "custom"
    },
    {
      "id": "custom_6c90dd68-5596-4d47-a436-5dcee50f395a",
      "question": "Are you smoke-free?",
      "answer": "100% smoke‑free apartment community.",
      "category": "Policies",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-woodstock-on-fuze",
      "search_query": "pet friendly apartments Woodstock ON",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Woodstock, ON",
      "h2_subtitle": "Discover pet friendly apartments in Woodstock, ON at FUZE Woodstock. Enjoy amenities designed for you and your pets.",
      "page_copy": "At FUZE Woodstock, we understand that pets are part of the family. That's why our pet friendly apartments in Woodstock, ON offer features to make you and your furry friends feel at home. Our dedicated pet wash station ensures that grooming your pet is a breeze, making post-walk clean-ups quick and easy. \n\nBeyond our pet amenities, FUZE Woodstock boasts a welcoming environment for all residents. Enjoy our rooftop lounge complete with a kitchen and terrace, perfect for relaxing evenings. For fitness enthusiasts, our 24-hour fitness center provides a convenient way to stay active any time of day. Choose FUZE Woodstock where pets and their owners are always welcome.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Woodstock, ON",
      "seo_description": "Find the ideal pet friendly apartments in Woodstock, ON with FUZE Woodstock's welcoming atmosphere and pet-centric amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "rooftop-lounge-apartments-oxford-county-fuze",
      "search_query": "apartments with rooftop lounge Oxford County",
      "category": "Amenity",
      "h1_title": "Apartments with Rooftop Lounge in Oxford County",
      "h2_subtitle": "Embrace luxury living in Oxford County with our apartments featuring a rooftop lounge. Enjoy breathtaking views and modern comforts.",
      "page_copy": "Experience the pinnacle of comfort and style at FUZE Woodstock, where our apartments in Oxford County come with a stunning rooftop lounge. Ideal for social gatherings, the rooftop lounge includes a well-equipped kitchen and a spacious terrace, allowing residents to enjoy exceptional views while entertaining guests or unwinding after a long day.\n\nIn addition to our remarkable rooftop amenities, FUZE Woodstock offers a suite of conveniences designed to enhance your lifestyle. From a modern 24-hour fitness center to a resident lounge with games like ping-pong and foosball, we provide a diversified living experience. Our eco-conscious energy-efficient insulation ensures lower utility costs, making FUZE Woodstock a smart and stylish choice.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Rooftop Lounge in Oxford County",
      "seo_description": "Explore Oxford County's luxury living with FUZE Woodstock's apartments featuring a rooftop lounge. Perfect views and amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "24-hour-gym-apartments-woodstock-n4v0e3-fuze",
      "search_query": "24 hour gym apartments Woodstock N4V 0E3",
      "category": "Amenity",
      "h1_title": "24 Hour Gym Apartments in Woodstock N4V 0E3",
      "h2_subtitle": "Stay fit at any hour in Woodstock N4V 0E3! Enjoy the convenience of our 24-hour gym at FUZE Woodstock.",
      "page_copy": "Nestled in the heart of Woodstock, FUZE Woodstock offers modern living with the perks of a 24-hour gym, so you can maintain your fitness routine whenever it suits you. Located in the N4V 0E3 area, our community provides state-of-the-art fitness facilities, allowing residents to stay active 24/7.\n\nBeyond our fitness amenities, FUZE Woodstock ensures a well-rounded living experience with features like a resident lounge equipped with ping-pong and foosball, and a rooftop lounge perfect for relaxation and socializing. Our energy-efficient insulation not only contributes to sustainability but also helps reduce utility costs, creating an ideal living environment. Choose FUZE Woodstock, where convenience and comfort come together.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24 Hour Gym Apartments in Woodstock N4V 0E3",
      "seo_description": "Find 24-hour gym apartments in Woodstock N4V 0E3 at FUZE Woodstock, offering fitness facilities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "residents-lounge-games-apartments-woodstock-fuze",
      "search_query": "apartment with residents lounge and games in Woodstock",
      "category": "Amenity",
      "h1_title": "Apartment with Residents Lounge in Woodstock",
      "h2_subtitle": "Enjoy a vibrant lifestyle in Woodstock with our residents lounge. Our apartments offer gaming options like ping-pong and foosball.",
      "page_copy": "FUZE Woodstock invites you to experience community living with a twist. Our apartment complex in Woodstock features a delightful residents lounge where you can relax or challenge friends in games like ping-pong and foosball. It's the perfect setting for socializing and making new friends.\n\nBeyond the lounge, FUZE Woodstock offers a range of amenities designed to enhance your living experience. Unwind at the rooftop lounge with a terrace and kitchen, or maintain your fitness routine in our 24-hour gym. Our energy-efficient insulation keeps utility costs low, ensuring a comfortable and economical stay. FUZE Woodstock provides the perfect blend of leisure and luxury.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Residents Lounge in Woodstock",
      "seo_description": "Discover Woodstock living at FUZE Woodstock with a residents lounge and games. Enjoy community and comfort in our apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "energy-efficient-low-utility-cost-apartments-woodstock-fuze",
      "search_query": "energy efficient apartments with low utility costs Woodstock",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments in Woodstock",
      "h2_subtitle": "Looking for energy-efficient living in Woodstock? Discover our apartments designed with cost-saving insulation and modern comforts.",
      "page_copy": "At FUZE Woodstock, sustainability meets comfort in our energy-efficient apartments designed for low utility costs. Located in the vibrant community of Woodstock, our homes feature advanced insulation technology that minimizes energy consumption while maintaining a comfortable atmosphere year-round.\n\nResidents at FUZE Woodstock not only enjoy the financial benefits of reduced energy bills but also have access to top-tier amenities. Utilize the 24-hour fitness center, lounge in the rooftop area with a kitchen, or play games like ping-pong in the resident lounge. Our pet wash station adds another layer of convenience, making FUZE Woodstock the ultimate choice for eco-friendly, modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Apartments in Woodstock",
      "seo_description": "Discover low utility cost living in Woodstock at FUZE Woodstock, where energy efficiency is a priority in our apartment designs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "studio-apartments-woodstock-on-fuze",
      "search_query": "studio apartments woodstock on",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Woodstock, ON",
      "h2_subtitle": "Explore cozy studio living in Woodstock, ON, at FUZE Woodstock. Our modern studios are designed for comfort and convenience.",
      "page_copy": "Discover the charm of compact living with studio apartments at FUZE Woodstock, located in the bustling community of Woodstock, ON. Our studios are expertly designed to maximize space while providing all the modern amenities you need for a comfortable lifestyle.\n\nAt FUZE Woodstock, enjoy the luxury of a rooftop lounge, game-equipped resident lounge, and a 24-hour fitness center that fits your schedule. With energy-efficient insulation, our studios offer not only style and convenience but also low utility costs. Relish in pet-friendly features like our pet wash station, making FUZE Woodstock a welcoming home for all.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Woodstock, ON",
      "seo_description": "Find modern studio apartments in Woodstock, ON at FUZE Woodstock, offering comfort and energy efficiency.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "one-bedroom-rentals-oxford-county-fuze",
      "search_query": "one bedroom rentals in oxford county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Rentals in Oxford County",
      "h2_subtitle": "Discover ideal one-bedroom rentals in Oxford County at FUZE Woodstock. Enjoy modern designs and various amenities for a fulfilling lifestyle.",
      "page_copy": "FUZE Woodstock offers premium one-bedroom rentals located in the heart of Oxford County. Our thoughtfully designed spaces provide a comfortable and stylish setting, perfect for singles or couples seeking a serene living environment.\n\nHere, residents benefit from a collection of upscale amenities. Embrace low utility bills thanks to energy-efficient insulation, stay active in our 24-hour fitness center, or relax in the rooftop lounge that serves as a community hub. The residents lounge, complete with games like ping-pong, fosters social interaction, while our pet wash station caters to pet owners. FUZE Woodstock is the perfect blend of community living and personal comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Rentals in Oxford County",
      "seo_description": "Explore FUZE Woodstock for one-bedroom rentals in Oxford County, offering modern amenities and sustainable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-n4v-0e3-fuze",
      "search_query": "two bedroom apartments near n4v 0e3",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near N4V 0E3",
      "h2_subtitle": "Discover spacious two-bedroom apartments near N4V 0E3 at FUZE Woodstock, featuring premium amenities and energy-efficient design.",
      "page_copy": "At FUZE Woodstock, we offer the perfect blend of space and convenience with our two-bedroom apartments located near N4V 0E3. These apartments are crafted to provide a comfortable and efficient living environment, featuring energy-efficient insulation that helps lower utility costs and sustain a cozy atmosphere.\n\nResidents enjoy access to exceptional amenities that complement their lifestyle. Our 24-hour fitness center, vibrant resident lounge with games, and well-appointed rooftop lounge offer endless opportunities for relaxation and socializing. The pet wash station and modern conveniences suit both families and professionals looking to enjoy life in the heart of Woodstock.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near N4V 0E3",
      "seo_description": "Find spacious two-bedroom apartments near N4V 0E3 at FUZE Woodstock, featuring modern amenities and energy-efficient designs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "apartments-near-fanshawe-college-woodstock",
      "search_query": "apartments near fanshawe college woodstock campus",
      "category": "School",
      "h1_title": "Apartments Near Fanshawe College Woodstock",
      "h2_subtitle": "Discover convenient apartments near Fanshawe College Woodstock Campus at FUZE Woodstock, perfect for students and faculty alike.",
      "page_copy": "If you're looking for a convenient, modern place to live near Fanshawe College Woodstock Campus, FUZE Woodstock is the perfect choice. Our apartments offer a blend of comfort and accessibility, ideal for students, faculty, and staff alike.\n\nLocated just a short distance from the campus, FUZE Woodstock provides easy access to a comprehensive range of amenities. Enjoy energy-efficient living with lower utility bills, take advantage of a 24-hour fitness center to fit any schedule, and unwind in our vibrant resident lounge. Pet owners will appreciate our on-site pet wash station, while everyone can enjoy social gatherings at the beautiful rooftop lounge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fanshawe College Woodstock",
      "seo_description": "Live near Fanshawe College Woodstock Campus at FUZE Woodstock, offering modern, convenient apartments with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "apartments-near-woodstock-hospital-fuze",
      "search_query": "apartments near Woodstock Hospital ON",
      "category": "Hospital",
      "h1_title": "Apartments Near Woodstock Hospital ON",
      "h2_subtitle": "Explore perfect living options with FUZE Woodstock's apartments near Woodstock Hospital, ON, featuring top-notch amenities for a comfortable stay.",
      "page_copy": "FUZE Woodstock offers conveniently located apartments for those seeking residences near Woodstock Hospital, ON. Our modern design focuses on comfort and accessibility, making FUZE the ideal choice for healthcare professionals and patients' families seeking nearby accommodations.\n\nExperience a hassle-free lifestyle with energy-efficient insulation reducing utility costs, and enjoy wellness with our fully-equipped 24-hour fitness center. Meet neighbors or relax with friends in our resident lounge or rooftop terrace, and keep pets clean and happy with our dedicated pet wash station. FUZE Woodstock blends convenience with premium living to suit all your needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Woodstock Hospital ON",
      "seo_description": "Find comfort at FUZE Woodstock, offering apartments near Woodstock Hospital ON with modern amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "apartments-near-pittock-conservation-area",
      "search_query": "apartments near Pittock Conservation Area Woodstock",
      "category": "Park",
      "h1_title": "Apartments Near Pittock Conservation Area",
      "h2_subtitle": "Discover ideal apartments near Pittock Conservation Area at FUZE Woodstock, offering nature lovers the perfect balance of convenience and tranquility.",
      "page_copy": "For those who love the great outdoors, FUZE Woodstock provides an ideal living destination with our apartments near Pittock Conservation Area in Woodstock. Enjoy the serene natural beauty while having the convenience of city amenities at your doorstep.\n\nOur residents benefit from eco-friendly living with energy-efficient insulation, ensuring a comfortable home environment year-round. Engage in a healthy lifestyle with our 24-hour fitness center, unwind in the resident lounge, or enjoy scenic views from the rooftop lounge with kitchen and terrace. FUZE Woodstock allows you to experience both the tranquility of nature and modern, convenient living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pittock Conservation Area",
      "seo_description": "Live close to nature at FUZE Woodstock, with apartments near Pittock Conservation Area offering modern amenities and peaceful surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "apartments-close-to-southside-park-n4v",
      "search_query": "apartments close to Southside Park N4V",
      "category": "Park",
      "h1_title": "Apartments Close to Southside Park N4V",
      "h2_subtitle": "Find your perfect home in FUZE Woodstock's apartments close to Southside Park N4V, combining nature's beauty with urban convenience.",
      "page_copy": "Located in proximity to the lush landscapes of Southside Park N4V, FUZE Woodstock offers unique apartments for those who value both nature and convenience. Step outside your door and find yourself immersed in the beauty of this community hub, perfect for leisure and recreation.\n\nFUZE Woodstock provides an exceptional living experience with amenities designed for both relaxation and activity. Our energy-efficient homes keep costs low while offering a range of features like a 24-hour fitness center and a pet wash station. Socialize in the resident lounge or enjoy panoramic views from the rooftop terrace. Experience vibrant living near Southside Park at FUZE Woodstock.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Southside Park N4V",
      "seo_description": "Explore FUZE Woodstock's apartments close to Southside Park N4V, the perfect blend of nature and modern living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "rentals-by-roth-park-oxford-county",
      "search_query": "rentals by Roth Park Oxford County",
      "category": "Park",
      "h1_title": "Rentals by Roth Park Oxford County",
      "h2_subtitle": "Discover exquisite rentals by Roth Park in Oxford County at FUZE Woodstock, where scenic views meet premier amenities.",
      "page_copy": "Situated near the picturesque Roth Park in Oxford County, FUZE Woodstock offers luxurious rentals that cater to both nature enthusiasts and those seeking refined urban living. Our location provides easy access to the serene parkscape while maintaining proximity to Woodstock's vibrant community life.\n\nExperience the seamless blend of nature and modernity at FUZE Woodstock with energy-efficient features designed to lower utility costs. Residents enjoy a comprehensive 24-hour fitness center and inviting spaces like our resident lounge and rooftop terrace. FUZE Woodstock is the quintessential choice for those wanting upscale rentals close to Roth Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Roth Park Oxford County",
      "seo_description": "FUZE Woodstock presents rentals by Roth Park in Oxford County, offering luxurious living with access to natural beauty and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167809",
      "source": "generator",
      "page_item_url": "apartments-nearby-pittock-dam-parking-lot-south-side",
      "search_query": "apartments nearby Pittock Dam Parking Lot South Side ON",
      "category": "Park",
      "h1_title": "Apartments Near Pittock Dam South Side",
      "h2_subtitle": "Explore our apartments nearby Pittock Dam Parking Lot South Side ON at FUZE Woodstock, offering easy access to outdoor adventures and modern comforts.",
      "page_copy": "Discover the advantages of living at FUZE Woodstock, where our apartments are conveniently located nearby Pittock Dam Parking Lot on the South Side, ON. Enjoy unparalleled access to outdoor activities and stunning views right outside your door.\n\nFUZE Woodstock seamlessly integrates natural beauty with contemporary amenities. Our energy-efficient apartments help manage utility expenses, and residents benefit from a host of facilities including a pet wash station, a 24-hour fitness center, and a lively resident lounge. Make the most of urban living while being close to the natural allure of Pittock Dam at FUZE Woodstock.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pittock Dam South Side",
      "seo_description": "Live conveniently at FUZE Woodstock in apartments near Pittock Dam Parking Lot South Side ON, blending nature access with modern facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "13230450438"
    },
    {
      "ID": "custom_fenix_chatbot",
      "type": "STRING",
      "value": "30164"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Aster"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "58883866514"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/gow32291p2m"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_repli_id": "13230450438",
  "custom_fenix_chatbot": "30164",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Aster",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "58883866514",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/gow32291p2m",
  "custom_website_subscription": "turnkey",
  "custom_audioeye_site_id": "41293f99-e9b3-47f1-a705-d738846dfe59",
  "custom_audioeye_site_hash": "aa23d7f5d5076843ec37fdd6e3e3de2d"
};

export const generatedAt = '2026-11-03T18:40:19.783Z';
